import React, { useState, useRef, useEffect } from "react";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment-timezone';
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../config/config.json";
import downloadIcon from '../../assets/images/icons/download_icon.svg';
import { useLocation } from "react-router-dom";
import { Input, Button, Table, Row, Col, Pagination, Select, Tooltip, Checkbox, Modal, Dropdown as AntDropdown } from 'antd';
import { saveAs } from "file-saver";
import FullLoader from "../../assets/images/full-page-loader.gif"
import mediaKitIcon from '../../assets/images/icons/export_download_icon.svg';
import { notifyfailure, notifysuccess, notifycatch } from "../../utils/toast";
import prevIcon from '../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../assets/images/icons/chevron-right.svg';
import TableLoading from "../../design/reportingv2/TableLoading";
import noData from '../../assets/images/data-graph/no-data.svg';
import error2Data from '../../assets/images/data-graph/error2-data.svg';
import errorData from '../../assets/images/data-graph/error-data.svg';
import { Link } from 'react-router-dom'
import * as XLSX from "xlsx";
import reportInfo from '../../assets/images/icons/report_info.svg';
import partialDataIcon from '../../assets/images/icons/parital_data_icon.svg';
import timeDataIcon from '../../assets/images/icons/time_data_icon.svg';
import searchIcon from '../../assets/images/icons/search.svg';
import ConstantMapping from './ReportMapping.json';
import { TreeSelect } from "antd";
import requestsIcon from '../../assets/images/icons/requests.svg';
import bidsIcon from '../../assets/images/icons/bids.svg';
import clicksIcon from '../../assets/images/icons/clicks.svg';
import impressionsIcon from '../../assets/images/icons/impressions_new.svg';

const { Option } = Select;

const DemandReport = (props) => {

    useEffect(() => {
        if ((props.role === "admin" || props.role === "u_admin")) {

            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
                let token = Cookies.get("token_xapads_ssp");
                axios
                    .post(configData.SERVER_URL + "pubReport/pubZoneList", { "pubId": [] }, {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        }
                    },)
                    .then(res => {
                        setZoneListOptions(res.data.data.zone)
                        setZoneList([])
                        setDomainListOptions(res.data.data.web)
                        setDomainList([])
                        setMobileListOptions(res.data.data.mobile)
                        setMobileList([])
                        setCtvListOptions(res.data.data.ctv)
                        setCtvList([])
                    })
                    .catch(() => { });
            }
        }

    }, [props.role])

    useEffect(() => {
        if (props.role === "admin" || props.role === "u_admin") {
            setDimensionsListOptions(prev => prev.filter(option => option.value !== "remotefeed_provider"));
        }
    }, [props.role])

    const [tileRequests, setTileRequests] = useState(null);
    const [tileBids, setTileBids] = useState(null);
    const [tileClicks, setTileClicks] = useState(null);
    const [tileImpressions, setTileImpressions] = useState(null);


    function formatNumber(num) {
        if (num === null || num === undefined) return "";

        const absNum = Math.abs(num);

        if (absNum >= 1e15) {
            return (num / 1e15).toFixed(1).replace(/\.0$/, "") + "Q";
        } else if (absNum >= 1e12) {
            return (num / 1e12).toFixed(1).replace(/\.0$/, "") + "T";
        } else if (absNum >= 1e9) {
            return (num / 1e9).toFixed(1).replace(/\.0$/, "") + "B";
        } else if (absNum >= 1e6) {
            return (num / 1e6).toFixed(1).replace(/\.0$/, "") + "M";
        } else if (absNum >= 1e3) {
            return (num / 1e3).toFixed(1).replace(/\.0$/, "") + "K";
        } else {
            return num.toString();
        }
    }


    function resetFilter() {
        setDateRange({
            start: pstYesterday.clone(),
            end: pstYesterday.clone(),
        })
        setPickerKey(prev => prev + 1);
        setLabelName("Yesterday");
        setPlatformList([])
        setCountryList([])
        setPublisherList([])

        if ((props.role !== "admin" && props.role !== "u_admin")) {
            setZoneListOptions([]);
            setDomainListOptions([]);
            setMobileListOptions([]);
            setCtvListOptions([]);
        }

        setZoneList([])
        setDomainList([])
        setMobileList([])
        setCtvList([])
        setTrafficTypeList([])
        setDeviceTypeList([])
        setDimensionsList(["publisher"])

        setSearchPlatformList("")
        setSearchCountryList("")
        setSearchPublisherList("")
        setSearchZoneList("")
        setSearchDomainList("")
        setSearchMobileList("")
        setSearchCtvList("")
        setSearchTrafficTypeList("")
        setSearchDeviceTypeList("")
        setSearchDimensionsList("")
    }



    //---------------------------------final code working ------------------------------------------------

    //filters ---------------------------------------------------------------------------------------------

    // ///////////////////date range picker code ////////////////////////
    // All date logic is driven by PST timezone (America/Los_Angeles handles DST automatically).
    // Works in BOTH directions:
    //   • User ahead of PST (e.g. India, local=25th, PST=24th) → Today=24, 25th disabled
    //   • User behind PST (e.g. local=24th, PST=25th)          → Today=25, not 24
    const pstToday = moment().tz("America/Los_Angeles").startOf('day');
    const pstYesterday = pstToday.clone().subtract(1, 'days');

    const [dateRange, setDateRange] = useState({
        start: pstYesterday.clone(),
        end: pstYesterday.clone(),
    });
    const [dateRangePreviousApplied, setDateRangePreviousApplied] = useState({
        start: pstYesterday.clone(),
        end: pstYesterday.clone(),
    });

    // const [dateRange, setDateRange] = useState({
    //     start: moment("2025-02-05T18:30:00.000Z"),
    //     end: moment("2025-02-21T18:29:59.999Z")
    // });

    const [pickerKey, setPickerKey] = useState(0);
    const [labelName, setLabelName] = useState("Yesterday");
    const { start, end } = dateRange;
    const label =
        start?.format('DD/MM/YYYY') + ' - ' + end?.format('DD/MM/YYYY');
    const datepickerRef = useRef(null);
    const [hasClass, setHasClass] = useState(false);

    useEffect(() => {
        const checkClass = () => {
            const daterangepicker = document.querySelector(".daterangepicker");
            if (daterangepicker && window.getComputedStyle(daterangepicker).display === "block") {
                setHasClass(true);
            } else {
                setHasClass(false);
            }
        };

        checkClass();

        // Observe DOM changes
        const observer = new MutationObserver(checkClass);
        observer.observe(document.body, { attributes: true, childList: true, subtree: true });

        return () => observer.disconnect();
    });

    ////////////////////////////////platform code starts ///////////////////

    const [platformList, setPlatformList] = useState([]);
    const [platformListPreviousApplied, setPlatformListPreviousApplied] = useState([]);
    const [platformListOptions, setPlatformListOptions] = useState(ConstantMapping.PlatformType_Options);
    const [searchPlatformList, setSearchPlatformList] = useState('');

    const handleSearchPlatformList = (e) => {
        setSearchPlatformList(e.target.value);
    };

    const filterPlatformList = platformListOptions?.filter(option =>
        option.label.toLowerCase()?.includes(searchPlatformList.toLowerCase())
    );

    function handleSelectAllPlatformList() {
        const allValues = platformListOptions.map(option => option.value);
        let tempPlatformList = [];
        if (platformList?.length !== platformListOptions?.length) {
            tempPlatformList = [...allValues];
        } else {
            tempPlatformList = [];
        }
        setPlatformList(tempPlatformList);
    }

    function handlePlatformList(value) {
        let tempPlatformList = [...platformList]
        let newValue = [];
        if (tempPlatformList?.includes(value)) {
            newValue = tempPlatformList.filter((item) => item !== value);
        } else {
            newValue = [...tempPlatformList, value];
        }
        tempPlatformList = newValue
        setPlatformList(tempPlatformList)

    }

    ////////////////////////////////platform code ends ///////////////////

    ////////////////////////////////country code starts ///////////////////


    useEffect(() => {
        // let status = Cookies.get("token_xapads_ssp") ? true : false;
        // if (status) {
        //     let token = Cookies.get("token_xapads_ssp");
        //     axios
        //         .get(configData.SERVER_URL + "ops/getCountryList", {
        //             headers: {
        //                 "Content-Type": "countrylication/json",
        //                 "x-access-token": token,
        //             }
        //         },)
        //         .then(res => {
        //             setCountryListOptions(res.data.data); // label/value array
        //         })
        //         .catch(() => { });
        // }

        setCountryListOptions(props.countryListOptionsViaParent)

    }, [props.countryListOptionsViaParent])

    const [countryList, setCountryList] = useState([]);
    const [countryListPreviousApplied, setCountryListPreviousApplied] = useState([]);
    const [countryListOptions, setCountryListOptions] = useState([]);
    const [searchCountryList, setSearchCountryList] = useState('');

    const handleSearchCountryList = (e) => {
        setSearchCountryList(e.target.value);
    };

    const filterCountryList = countryListOptions?.filter(option =>
        option.label.toLowerCase()?.includes(searchCountryList.toLowerCase())
    );

    function handleSelectAllCountryList() {
        const allValues = countryListOptions.map(option => option.value);
        let tempCountryList = [];
        if (countryList?.length !== countryListOptions?.length) {
            tempCountryList = [...allValues];
        } else {
            tempCountryList = [];
        }
        setCountryList(tempCountryList);
    }

    function handleCountryList(value) {
        let tempCountryList = [...countryList]
        let newValue = [];
        if (tempCountryList?.includes(value)) {
            newValue = tempCountryList.filter((item) => item !== value);
        } else {
            newValue = [...tempCountryList, value];
        }
        tempCountryList = newValue
        setCountryList(tempCountryList)

    }

    ////////////////////////////////country code ends ///////////////////

    ////////////////////////////////publisher code starts ///////////////////

    useEffect(() => {
        // let status = Cookies.get("token_xapads_ssp") ? true : false;
        // if (status) {
        //     let token = Cookies.get("token_xapads_ssp");
        //     axios
        //         .get(configData.SERVER_URL + "pubReport/pubList", {
        //             headers: {
        //                 "Content-Type": "application/json",
        //                 "x-access-token": token,
        //             }
        //         },)
        //         .then(res => {
        //             // if (res.data?.status) {
        //             setPublisherListOptions(res.data.data); // label/value array
        //             // }
        //         })
        //         .catch(() => { });
        // }

        setPublisherListOptions(props.publisherListOptionsViaParent)

    }, [props.publisherListOptionsViaParent])

    const [publisherList, setPublisherList] = useState([]);
    const [publisherListPreviousApplied, setPublisherListPreviousApplied] = useState([]);
    const [publisherListOptions, setPublisherListOptions] = useState([]);
    const [searchPublisherList, setSearchPublisherList] = useState('');

    const handleSearchPublisherList = (e) => {
        setSearchPublisherList(e.target.value);
    };

    const filterPublisherList = publisherListOptions?.filter(option =>
        option.label.toLowerCase()?.includes(searchPublisherList.toLowerCase())
    );

    function handleSelectAllPublisherList() {
        const allValues = publisherListOptions.map(option => option.value);
        let tempPublisherList = [];
        if (publisherList?.length !== publisherListOptions?.length) {
            tempPublisherList = [...allValues];

            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
                let token = Cookies.get("token_xapads_ssp");
                axios
                    .post(configData.SERVER_URL + "pubReport/pubZoneList", { "pubId": allValues }, {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        }
                    },)
                    .then(res => {
                        setZoneListOptions(res.data.data.zone)
                        setZoneList([])
                        setDomainListOptions(res.data.data.web)
                        setDomainList([])
                        setMobileListOptions(res.data.data.mobile)
                        setMobileList([])
                        setCtvListOptions(res.data.data.ctv)
                        setCtvList([])
                    })
                    .catch(() => { });
            }

        } else {
            tempPublisherList = [];
            setZoneListOptions([])
            setZoneList([])
            setDomainListOptions([])
            setDomainList([])
            setMobileListOptions([])
            setMobileList([])
            setCtvListOptions([])
            setCtvList([])
        }
        setPublisherList(tempPublisherList);

    }

    // function handlePublisherList(value) {

    //     let tempPublisherList = [...publisherList]
    //     let newValue = [];
    //     if (tempPublisherList?.includes(value)) {
    //         newValue = tempPublisherList.filter((item) => item !== value);

    //         setPublisherListOptions((prevOptions) =>
    //             prevOptions.map((option) => {
    //                 if (value === "site_domain") {
    //                     return option.value === "app_bundle"
    //                         ? { ...option, disabled: false }
    //                         : option;
    //                 } else if (value === "app_bundle") {
    //                     return option.value === "site_domain"
    //                         ? { ...option, disabled: false }
    //                         : option;
    //                 } else {
    //                     return option;
    //                 }
    //             })
    //         );

    //     } else {
    //         newValue = [...tempPublisherList, value];

    //         setPublisherListOptions((prevOptions) =>
    //             prevOptions.map((option) => {
    //                 if (value === "site_domain") {
    //                     return option.value === "app_bundle"
    //                         ? { ...option, disabled: true }
    //                         : option;
    //                 } else if (value === "app_bundle") {
    //                     return option.value === "site_domain"
    //                         ? { ...option, disabled: true }
    //                         : option;
    //                 } else {
    //                     return option;
    //                 }
    //             })
    //         );
    //     }


    //     let status = Cookies.get("token_xapads_ssp") ? true : false;
    //     if (status) {
    //         let token = Cookies.get("token_xapads_ssp");
    //         axios
    //             .post(configData.SERVER_URL + "pubReport/pubZoneList", { "pubId": newValue }, {
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                     "x-access-token": token,
    //                 }
    //             },)
    //             .then(res => {
    //                 setZoneListOptions(res.data.data.zone)
    //                 setZoneList([])
    //                 setDomainListOptions(res.data.data.web)
    //                 setDomainList([])
    //                 setMobileListOptions(res.data.data.mobile)
    //                 setMobileList([])
    //                 setCtvListOptions(res.data.data.ctv)
    //                 setCtvList([])
    //             })
    //             .catch(() => { });
    //     }

    //     tempPublisherList = newValue
    //     setPublisherList(tempPublisherList)


    // }

    const handlePublisherList = (values) => {
        setPublisherList(values);

        if (values.length > 0) {
            let status = Cookies.get("token_xapads_ssp");
            if (!status) return;

            axios.post(
                configData.SERVER_URL + "pubReport/pubZoneList",
                { pubId: values },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": status,
                    },
                }
            ).then(res => {
                // setZoneListOptions(res.data.data.zone);
                // setZoneList([]);
                // setDomainListOptions(res.data.data.web);
                // setDomainList([]);
                // setMobileListOptions(res.data.data.mobile);
                // setMobileList([]);
                // setCtvListOptions(res.data.data.ctv);
                // setCtvList([]);

                const { zone, web, mobile, ctv } = res.data.data;

                // ZONE
                setZoneListOptions(zone);
                setZoneList(prev =>
                    prev.filter(val => zone.some(z => z.value === val))
                );

                // DOMAIN
                setDomainListOptions(web);
                setDomainList(prev =>
                    prev.filter(val => web.some(w => w.value === val))
                );

                // MOBILE
                setMobileListOptions(mobile);
                setMobileList(prev =>
                    prev.filter(val => mobile.some(m => m.value === val))
                );

                // CTV
                setCtvListOptions(ctv);
                setCtvList(prev =>
                    prev.filter(val => ctv.some(c => c.value === val))
                );
            })
                .catch(error => {
                    setZoneListOptions([]);
                    setZoneList([]);
                    setDomainListOptions([]);
                    setDomainList([]);
                    setMobileListOptions([]);
                    setMobileList([]);
                    setCtvListOptions([]);
                    setCtvList([]);
                });

        }
        else {
            setZoneListOptions([]);
            setZoneList([]);
            setDomainListOptions([]);
            setDomainList([]);
            setMobileListOptions([]);
            setMobileList([]);
            setCtvListOptions([]);
            setCtvList([]);
        }



    };

    ////////////////////////////////publisher code ends ///////////////////


    ////////////////////////////////zone code starts ///////////////////

    const [zoneList, setZoneList] = useState([]);
    const [zoneListPreviousApplied, setZoneListPreviousApplied] = useState([]);
    const [zoneListOptions, setZoneListOptions] = useState([]);
    const [searchZoneList, setSearchZoneList] = useState('');

    const handleSearchZoneList = (e) => {
        setSearchZoneList(e.target.value);
    };

    const filterZoneList = zoneListOptions?.filter(option =>
        option.label.toLowerCase()?.includes(searchZoneList.toLowerCase())
    );

    function handleSelectAllZoneList() {
        const allValues = zoneListOptions.map(option => option.value);
        let tempZoneList = [];
        if (zoneList?.length !== zoneListOptions?.length) {
            tempZoneList = [...allValues];
        } else {
            tempZoneList = [];
        }
        setZoneList(tempZoneList);
    }

    function handleZoneList(value) {
        let tempZoneList = [...zoneList]
        let newValue = [];
        if (tempZoneList?.includes(value)) {
            newValue = tempZoneList.filter((item) => item !== value);
        } else {
            newValue = [...tempZoneList, value];
        }
        tempZoneList = newValue
        setZoneList(tempZoneList)

    }

    ////////////////////////////////zone code ends ///////////////////

    ////////////////////////////////domain code starts ///////////////////

    const [domainList, setDomainList] = useState([]);
    const [domainListPreviousApplied, setDomainListPreviousApplied] = useState([]);
    const [domainListOptions, setDomainListOptions] = useState([]);
    const [searchDomainList, setSearchDomainList] = useState('');

    const handleSearchDomainList = (e) => {
        setSearchDomainList(e.target.value);
    };

    const filterDomainList = domainListOptions?.filter(option =>
        option.label.toLowerCase()?.includes(searchDomainList.toLowerCase())
    );

    function handleSelectAllDomainList() {
        const allValues = domainListOptions.map(option => option.value);
        let tempDomainList = [];
        if (domainList?.length !== domainListOptions?.length) {
            tempDomainList = [...allValues];
        } else {
            tempDomainList = [];
        }
        setDomainList(tempDomainList);
    }

    function handleDomainList(value) {
        let tempDomainList = [...domainList]
        let newValue = [];
        if (tempDomainList?.includes(value)) {
            newValue = tempDomainList.filter((item) => item !== value);
        } else {
            newValue = [...tempDomainList, value];
        }
        tempDomainList = newValue
        setDomainList(tempDomainList)

    }

    ////////////////////////////////domain code ends ///////////////////
    ////////////////////////////////mobile code starts ///////////////////

    const [mobileList, setMobileList] = useState([]);
    const [mobileListPreviousApplied, setMobileListPreviousApplied] = useState([]);
    const [mobileListOptions, setMobileListOptions] = useState([]);
    const [searchMobileList, setSearchMobileList] = useState('');

    const handleSearchMobileList = (e) => {
        setSearchMobileList(e.target.value);
    };

    const filterMobileList = mobileListOptions?.filter(option =>
        option.label.toLowerCase()?.includes(searchMobileList.toLowerCase())
    );

    function handleSelectAllMobileList() {
        const allValues = mobileListOptions.map(option => option.value);
        let tempMobileList = [];
        if (mobileList?.length !== mobileListOptions?.length) {
            tempMobileList = [...allValues];
        } else {
            tempMobileList = [];
        }
        setMobileList(tempMobileList);
    }

    function handleMobileList(value) {
        let tempMobileList = [...mobileList]
        let newValue = [];
        if (tempMobileList?.includes(value)) {
            newValue = tempMobileList.filter((item) => item !== value);
        } else {
            newValue = [...tempMobileList, value];
        }
        tempMobileList = newValue
        setMobileList(tempMobileList)

    }

    ////////////////////////////////mobile code ends ///////////////////

    ////////////////////////////////ctv code starts ///////////////////

    const [ctvList, setCtvList] = useState([]);
    const [ctvListPreviousApplied, setCtvListPreviousApplied] = useState([]);
    const [ctvListOptions, setCtvListOptions] = useState([]);
    const [searchCtvList, setSearchCtvList] = useState('');

    const handleSearchCtvList = (e) => {
        setSearchCtvList(e.target.value);
    };

    const filterCtvList = ctvListOptions?.filter(option =>
        option.label.toLowerCase()?.includes(searchCtvList.toLowerCase())
    );

    function handleSelectAllCtvList() {
        const allValues = ctvListOptions.map(option => option.value);
        let tempCtvList = [];
        if (ctvList?.length !== ctvListOptions?.length) {
            tempCtvList = [...allValues];
        } else {
            tempCtvList = [];
        }
        setCtvList(tempCtvList);
    }

    function handleCtvList(value) {
        let tempCtvList = [...ctvList]
        let newValue = [];
        if (tempCtvList?.includes(value)) {
            newValue = tempCtvList.filter((item) => item !== value);
        } else {
            newValue = [...tempCtvList, value];
        }
        tempCtvList = newValue
        setCtvList(tempCtvList)

    }

    ////////////////////////////////ctv code ends ///////////////////

    ////////////////////////////////trafficType code starts ///////////////////


    const [trafficTypeList, setTrafficTypeList] = useState([]);
    const [trafficTypeListPreviousApplied, setTrafficTypeListPreviousApplied] = useState([]);
    const [trafficTypeListOptions, setTrafficTypeListOptions] = useState(ConstantMapping.TrafficType_Options);
    const [searchTrafficTypeList, setSearchTrafficTypeList] = useState('');

    const handleSearchTrafficTypeList = (e) => {
        setSearchTrafficTypeList(e.target.value);
    };

    const filterTrafficTypeList = trafficTypeListOptions?.filter(option =>
        option.label.toLowerCase()?.includes(searchTrafficTypeList.toLowerCase())
    );

    function handleSelectAllTrafficTypeList() {
        const allValues = trafficTypeListOptions.map(option => option.value);
        let tempTrafficTypeList = [];
        if (trafficTypeList?.length !== trafficTypeListOptions?.length) {
            tempTrafficTypeList = [...allValues];
        } else {
            tempTrafficTypeList = [];
        }
        setTrafficTypeList(tempTrafficTypeList);
    }

    function handleTrafficTypeList(value) {
        let tempTrafficTypeList = [...trafficTypeList]
        let newValue = [];
        if (tempTrafficTypeList?.includes(value)) {
            newValue = tempTrafficTypeList.filter((item) => item !== value);
        } else {
            newValue = [...tempTrafficTypeList, value];
        }
        tempTrafficTypeList = newValue
        setTrafficTypeList(tempTrafficTypeList)

    }

    ////////////////////////////////trafficType code ends ///////////////////

    ////////////////////////////////deviceType code starts ///////////////////


    const [deviceTypeList, setDeviceTypeList] = useState([]);
    const [deviceTypeListPreviousApplied, setDeviceTypeListPreviousApplied] = useState([]);
    const [deviceTypeListOptions, setDeviceTypeListOptions] = useState(ConstantMapping.DeviceType_Options);
    const [searchDeviceTypeList, setSearchDeviceTypeList] = useState('');

    const handleSearchDeviceTypeList = (e) => {
        setSearchDeviceTypeList(e.target.value);
    };

    const filterDeviceTypeList = deviceTypeListOptions?.filter(option =>
        option.label.toLowerCase()?.includes(searchDeviceTypeList.toLowerCase())
    );

    function handleSelectAllDeviceTypeList() {
        const allValues = deviceTypeListOptions.map(option => option.value);
        let tempDeviceTypeList = [];
        if (deviceTypeList?.length !== deviceTypeListOptions?.length) {
            tempDeviceTypeList = [...allValues];
        } else {
            tempDeviceTypeList = [];
        }
        setDeviceTypeList(tempDeviceTypeList);
    }

    function handleDeviceTypeList(value) {
        let tempDeviceTypeList = [...deviceTypeList]
        let newValue = [];
        if (tempDeviceTypeList?.includes(value)) {
            newValue = tempDeviceTypeList.filter((item) => item !== value);
        } else {
            newValue = [...tempDeviceTypeList, value];
        }
        tempDeviceTypeList = newValue
        setDeviceTypeList(tempDeviceTypeList)

    }

    ////////////////////////////////deviceType code ends ///////////////////

    ////////////////////////////////dimensions code starts ///////////////////

    const [dimensionsList, setDimensionsList] = useState(["publisher"]);
    const [dimensionsListPreviousApplied, setDimensionsListPreviousApplied] = useState([]);
    const [dimensionsListOptions, setDimensionsListOptions] = useState(ConstantMapping.Dimensions_Options_Demand);
    const [searchDimensionsList, setSearchDimensionsList] = useState('');

    const handleSearchDimensionsList = (e) => {
        setSearchDimensionsList(e.target.value);
    };

    const filterDimensionsList = dimensionsListOptions?.filter(option =>
        option.label.toLowerCase()?.includes(searchDimensionsList.toLowerCase())
    );

    function handleSelectAllDimensionsList() {
        const allValues = dimensionsListOptions.map(option => option.value);
        let tempDimensionsList = [];
        if (dimensionsList?.length !== dimensionsListOptions?.length) {
            tempDimensionsList = [...allValues];
        } else {
            tempDimensionsList = [];
        }
        setDimensionsList(tempDimensionsList);
    }



    // function handleDimensionsList(newList) {
    //     setDimensionsList(newList);

    //     setDimensionsListOptions((prevOptions) =>
    //         prevOptions.map((option) => {
    //             if (newList.includes("site_domain")) {
    //                 return option.value === "app_bundle"
    //                     ? { ...option, disabled: true }
    //                     : option;
    //             }

    //             if (newList.includes("app_bundle")) {
    //                 return option.value === "site_domain"
    //                     ? { ...option, disabled: true }
    //                     : option;
    //             }

    //             return { ...option, disabled: false };
    //         })
    //     );
    // }

    function handleDimensionsList(newList) {
        // Always keep publisher
        let updatedList = newList.includes("publisher")
            ? newList
            : ["publisher", ...newList];

        setDimensionsList(updatedList);

        setDimensionsListOptions((prevOptions) =>
            prevOptions.map((option) => {

                // publisher always disabled
                if (option.value === "publisher") {
                    return { ...option, disabled: true };
                }

                if (updatedList.includes("site_domain")) {
                    return option.value === "app_bundle"
                        ? { ...option, disabled: true }
                        : { ...option, disabled: false };
                }

                if (updatedList.includes("app_bundle")) {
                    return option.value === "site_domain"
                        ? { ...option, disabled: true }
                        : { ...option, disabled: false };
                }

                return { ...option, disabled: false };
            })
        );
    }

    ////////////////////////////////dimensions code ends ///////////////////




    //filters-----------------------------------------------------------------------------------------------------

    //---------------------------------final working working------------------------------------------------------



















    /*****************************************************/


    const columnsDummy = [
        {
            title: 'Publisher',
            dataIndex: 'publisher',
            fixed: 'left',
        },
        {
            title: 'Requests',
            dataIndex: 'requests',
        },
        {
            title: 'Responses',
            dataIndex: 'responses',
        },
        {
            title: 'Coverage %',
            dataIndex: 'coverage',
        },
        {
            title: 'Net Impressions',
            dataIndex: 'ni',
        },
        {
            title: 'Impression Win Rate',
            dataIndex: 'iwr',
        },
        {
            title: 'Net Clicks',
            dataIndex: 'net_clicks',
        },
        {
            title: 'Gross CTR %',
            dataIndex: 'gross_ctr',
        },
        {
            title: 'Net Revenue',
            dataIndex: 'net_revenue',
        },
        {
            title: 'Estimated eCPM',
            dataIndex: 'cpm',
            render: (data) => (
                <div className={`text_status --${data}`}>
                    {data}
                </div>

            ),
        },
    ];

    const dataDummy = [
        {
            publisher: 233,
            requests: 233,
            responses: 233,
            coverage: 233,
            ni: 233,
            iwr: 233,
            net_clicks: 233,
            gross_ctr: 233,
            net_revenue: 233,
            cpm: 'low',
        },
        {
            publisher: 233,
            requests: 233,
            responses: 233,
            coverage: 233,
            ni: 233,
            iwr: 233,
            net_clicks: 233,
            gross_ctr: 233,
            net_revenue: 233,
            cpm: 'low',
        },
        {
            publisher: 233,
            requests: 233,
            responses: 233,
            coverage: 233,
            ni: 233,
            iwr: 233,
            net_clicks: 233,
            gross_ctr: 233,
            net_revenue: 233,
            cpm: 'low',
        },
        {
            publisher: 233,
            requests: 233,
            responses: 233,
            coverage: 233,
            ni: 233,
            iwr: 233,
            net_clicks: 233,
            gross_ctr: 233,
            net_revenue: 233,
            cpm: 'low',
        },
        {
            publisher: 233,
            requests: 233,
            responses: 233,
            coverage: 233,
            ni: 233,
            iwr: 233,
            net_clicks: 233,
            gross_ctr: 233,
            net_revenue: 233,
            cpm: 'medium',
        }, {
            publisher: 233,
            requests: 233,
            responses: 233,
            coverage: 233,
            ni: 233,
            iwr: 233,
            net_clicks: 233,
            gross_ctr: 233,
            net_revenue: 233,
            cpm: 'medium',
        }, {
            publisher: 233,
            requests: 233,
            responses: 233,
            coverage: 233,
            ni: 233,
            iwr: 233,
            net_clicks: 233,
            gross_ctr: 233,
            net_revenue: 233,
            cpm: 'medium',
        }, {
            publisher: 233,
            requests: 233,
            responses: 233,
            coverage: 233,
            ni: 233,
            iwr: 233,
            net_clicks: 233,
            gross_ctr: 233,
            net_revenue: 233,
            cpm: 'medium',
        }, {
            publisher: 233,
            requests: 233,
            responses: 233,
            coverage: 233,
            ni: 233,
            iwr: 233,
            net_clicks: 233,
            gross_ctr: 233,
            net_revenue: 233,
            cpm: 'medium',
        }, {
            publisher: 233,
            requests: 233,
            responses: 233,
            coverage: 233,
            ni: 233,
            iwr: 233,
            net_clicks: 233,
            gross_ctr: 233,
            net_revenue: 233,
            cpm: 'medium',
        },
        {
            publisher: 233,
            requests: 233,
            responses: 233,
            coverage: 233,
            ni: 233,
            iwr: 233,
            net_clicks: 233,
            gross_ctr: 233,
            net_revenue: 233,
            cpm: 'medium',
        },

    ];

    // SingleSelect start
    const [searchingValue, setSearchingValue] = useState('');
    const [value, setValue] = useState(null);

    const optionsSingle = [
        { value: 'jack1', label: 'Jack 1' },
        { value: 'lucy1', label: 'Lucy 1' },
        { value: 'lucy8', label: 'Lucy 8' },
        { value: 'tom8', label: 'Tom 8' },
        { value: 'jack9', label: 'Jack 9' },
        { value: 'lucy9', label: 'Lucy 9' },
        { value: 'tom9', label: 'Tom 9' },
    ];

    const filteredSingleOptions = optionsSingle.filter(optionsSingle =>
        optionsSingle.label.toLowerCase().includes(searchingValue.toLowerCase())
    );
    // SingleSelect start
    // Multiselect start
    const [searchValue, setSearchValue] = useState('');
    const [filterApply, setFilterApply] = useState({
        publisher: [],
    });

    const options = [
        { value: 'jack1', label: 'Jack 1' },
        { value: 'lucy1', label: 'Lucy 1' },
        { value: 'lucy8', label: 'Lucy 8' },
        { value: 'tom8', label: 'Tom 8' },
        { value: 'jack9', label: 'Jack 9' },
        { value: 'lucy9', label: 'Lucy 9' },
        { value: 'tom9', label: 'Tom 9' },
    ];

    const handleSearch = (e) => {
        setSearchValue(e.target.value.toLowerCase());
    };
    const handleFilterApply = (type, value) => {
        setFilterApply((prev) => {
            const currentPublishers = prev.publisher;
            const isSelected = currentPublishers.includes(value);

            // Toggle selection
            const updatedPublishers = isSelected
                ? currentPublishers.filter((item) => item !== value)
                : [...currentPublishers, value];

            return { ...prev, publisher: updatedPublishers };
        });
    };

    // Filtering options based on search input
    const filteredOptions = options.filter((option) =>
        option.label.toLowerCase().includes(searchValue)
    );
    // Multiselect end 

    const onChange = (values) => {
        setFilterApply(prev => ({
            ...prev,
            publisher: values
        }));
    };
    const onChangeSelect = value => {
        console.log(`selected ${value}`);
    };

    const onSearch = value => {
        console.log('search:', value);
    };
    /*****************************************************/




    const savedReportFromListing = new URLSearchParams(useLocation().search).get("savedReport");
    const [pageLoad, setPageLoad] = useState(true)

    const [columnsAll, setColumnsAll] = useState([])
    const [exportHeader, setExportHeader] = useState([])

    const [errorScreen, setErrorScreen] = useState(false)
    const [data, setData] = useState([])
    const [exportData, setExportData] = useState([])
    const [totalData, setTotalData] = useState([])
    const [total, setTotal] = useState({})
    const [loading, setLoading] = useState(true)
    const [backendLoading, setBackendLoading] = useState(false)
    const [initialLoad, setInitialLoad] = useState(true)

    const [paginationProcess, setPaginationProcess] = useState("frontend")
    const [totalAdkRecords, setTotalAdkRecords] = useState(0)
    const [exportBackendLoading, setExportBackendLoading] = useState(false)
    const [page, setPage] = useState({
        current: 1,
        pageSize: 500,
        total: 0,
    });
    const [sortObject, setSortObject] = useState({
        name: "pub_gross_impressions",
        type: -1
    });

    const [search, setSearch] = useState("")
    const [colvis, setColvis] = useState({});
    const [colvisOptions, setColvisOptions] = useState([]);
    const isGenerateCallRef = useRef(false);


    useEffect(() => {

        if (savedReportFromListing) {
            setPageLoad(false)
        }
        else {
            setPageLoad(false)
        }

    }, []);

    function addCommasToNumber(num) {
        const isDecimal = num % 1 !== 0;
        let numStr = num.toString();
        let [wholePart, decimalPart] = numStr.split(".");
        wholePart = wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if (isDecimal) {
            numStr = `${wholePart}.${decimalPart}`;
        } else {
            numStr = wholePart;
        }

        return numStr;
    }

    function paginateArray(data, pageNo, limit, searchKey = "", sortKey = "", sortOrder = "") {

        let tempPage = page

        if (!Array.isArray(data) || data.length === 0) {
            setData([]);
            tempPage.total = 0
            setPage(tempPage);
            return;
        }
        else {
            const filteredData = searchKey
                ? data.filter(
                    (item) =>
                        item.publisher_id?.toString().toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.publisher?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.zone_id?.toString().toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.zone?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.country?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.traffic_type?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.dsp_adomain?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.device_type?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.remotefeed_provider?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.site_domain?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.app_bundle?.toLowerCase().includes(searchKey.toLowerCase())
                )
                : data;

            let sortedData;

            if (sortOrder !== "") {
                sortedData = sortKey
                    ? [...filteredData].sort((a, b) => {
                        const aValue = a[sortKey] ?? "";
                        const bValue = b[sortKey] ?? "";

                        if (typeof aValue === "string" && typeof bValue === "string") {
                            return aValue.localeCompare(bValue) * sortOrder;
                        }
                        return (aValue - bValue) * sortOrder;
                    })
                    : filteredData;

            }
            else {
                sortedData = filteredData
            }

            const startIndex = (pageNo - 1) * limit;
            const endIndex = startIndex + limit;
            const paginatedData = sortedData.slice(startIndex, endIndex);

            tempPage.current = pageNo
            if (paginationProcess === "backend" && search === "") {
                tempPage.total = totalAdkRecords
            }
            else {
                tempPage.total = sortedData.length
            }

            setPage(tempPage);

            setData(paginatedData);

        }
    }

    function paginateArrayFrontendCall(data, pageNo, limit, searchKey = "", sortKey = "", sortOrder = "") {

        let tempPage = page

        if (!Array.isArray(data) || data.length === 0) {
            setData([]);
            tempPage.total = 0
            setPage(tempPage);
            return;
        }
        else {
            const filteredData = searchKey
                ? data.filter(
                    (item) =>
                        item.publisher_id?.toString().toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.publisher?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.zone_id?.toString().toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.zone?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.country?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.traffic_type?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.dsp_adomain?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.device_type?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.remotefeed_provider?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.site_domain?.toLowerCase().includes(searchKey.toLowerCase()) ||
                        item.app_bundle?.toLowerCase().includes(searchKey.toLowerCase())
                )
                : data;

            let sortedData;

            if (sortOrder !== "") {
                sortedData = sortKey
                    ? [...filteredData].sort((a, b) => {
                        const aValue = a[sortKey] ?? "";
                        const bValue = b[sortKey] ?? "";

                        if (typeof aValue === "string" && typeof bValue === "string") {
                            return aValue.localeCompare(bValue) * sortOrder;
                        }
                        return (aValue - bValue) * sortOrder;
                    })
                    : filteredData;

            }
            else {
                sortedData = filteredData
            }

            const startIndex = (pageNo - 1) * limit;
            const endIndex = startIndex + limit;
            const paginatedData = sortedData.slice(startIndex, endIndex);

            tempPage.current = pageNo
            tempPage.pageSize = limit
            tempPage.total = sortedData.length

            setPage(tempPage);

            setData(paginatedData);

        }
    }

    const tableScrollRef = useRef(null);
    const scrollToItem = (ref, offset = 80) => {
        if (ref && ref.current) {
            ref.current.style.scrollMarginTop = `${offset}px`;
            ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
            setTimeout(() => {
                ref.current.style.scrollMarginTop = '';
            }, 500);
        }
    };


    const getDataViaFrontend = () => {
        setLoading(false)
        setInitialLoad(true)
        setData([])
        setTotalData([])
        setExportData([])
        setTotal([])
        setSortObject({
            name: "pub_gross_impressions",
            type: -1
        })

        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {

            let token = Cookies.get("token_xapads_ssp");

            let dataFor = 1;
            // let publisher_ids = [];
            // let zone_ids = []


            let dateRangeCall = {
                startDate: dateRange?.start.format('YYYY-MM-DD'),
                endDate: dateRange?.end.format('YYYY-MM-DD')
            };

            // if (platform === "Publica") {
            //     dataFor = 2
            // }

            let metricsListForCall = ["remotefeed_requests", "pub_response", "pub_gross_impressions", "pub_gross_clicks", "pub_ctr", "pub_fill_rate", "pub_avg_bidfloor", "pub_net_ecpm", "pub_revenue"]

            // let metricsListForCall = metricsList.flatMap(item => item === "pixalate" ? ConstantMapping.Pixalate_related_keys : item)

            // if (filterRepeater.length > 0) {
            //     for (let i = 0; i < filterRepeater.length; i++) {
            //         if (filterRepeater[i]["label"] === "platform") {
            //             if (filterRepeater[i]["value"].length === 1) {
            //                 dataFor = filterRepeater[i]["value"][0]
            //             }
            //         }

            //         if (filterRepeater[i]["label"] === "publisher") {
            //             publisher_ids = filterRepeater[i]["value"]
            //         }

            //         if (filterRepeater[i]["label"] === "zone") {
            //             zone_ids = filterRepeater[i]["value"]
            //         }
            //     }
            // }

            let filter = {
                "dataFor": dataFor,
                "country": countryList,
                "publisher_ids": publisherList,
                "zone_ids": zoneList,
                "traffic_type": trafficTypeList,
                "format_type": deviceTypeList,
                "site_domain": domainList,
                "mobile_app": mobileList,
                "ctv_app": ctvList,
                "dimensions": dimensionsList,
                metrics: ["remotefeed_requests", "pub_response", "pub_gross_impressions", "pub_gross_clicks", "pub_ctr", "pub_fill_rate", "pub_avg_bidfloor", "pub_net_ecpm", "pub_revenue"],
            }


            axios.post(configData.SERVER_URL + `report/`, {
                "filter": filter,
                "date": dateRangeCall,
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": token,
                },
            })
                .then((response) => {


                    if (response.data.data && response.data.data.length > 0) {

                        let tempPage = { ...page }
                        tempPage.current = 1
                        tempPage.total = response.data.totalRecords
                        setPage(tempPage)

                        setTotalData(response.data.data)
                        setTotal(response.data.total)
                        paginateArrayFrontendCall(response.data.data, 1, tempPage.pageSize, search, "", "")


                        //export Logic
                        let tempData = [...response.data.data];
                        let tempTotal = { ...response.data.total }; // Spread existing properties
                        let totalKey = ConstantMapping.Get_Dimensions_Set[dimensionsList[0]][0]
                        tempTotal[totalKey] = "Total";
                        tempData.push(tempTotal); // Append the updated object to the array
                        setExportData(tempData);
                        setErrorScreen(false)

                    }
                    else {
                        let tempPage = { ...page }
                        tempPage.current = 1
                        tempPage.total = 0
                        setPage(tempPage)
                        setTotalData([])
                        setTotal([])
                        setData([])
                        setExportData([])
                        setErrorScreen(false)
                    }


                    let updatedColumns1 = []
                    let updatedColumns2 = []
                    let updatedColumns3 = []
                    let updatedExportColumns1 = []
                    let updatedExportColumns2 = []
                    let updatedExportColumns3 = []
                    let fixedColumnCount = 0;


                    // ----------------------------------------
                    const priorityOrder = ["date", "publisher", "zone"];
                    const sortedDimensionsList = dimensionsList.sort((a, b) => {
                        const indexA = priorityOrder.indexOf(a);
                        const indexB = priorityOrder.indexOf(b);

                        if (indexA === -1 && indexB === -1) return 0;
                        if (indexA === -1) return 1;
                        if (indexB === -1) return -1;
                        return indexA - indexB;
                    });


                    //------------------------------------------

                    const showPlatformColumn =
                        (props.role !== "admin" && props.role !== "u_admin") && platformList.length === platformListOptions.length && dimensionsList.includes("zone");

                    for (let i = 0; i < sortedDimensionsList.length; i++) {

                        const values = ConstantMapping.Get_Dimensions_Set[sortedDimensionsList[i]]

                        if (values !== undefined) {
                            for (let j = 0; j < values.length; j++) {
                                updatedColumns1.push(provideDynamicHeaderColumns(values[j], fixedColumnCount, false, "", ""))
                                updatedExportColumns1.push(provideDynamicExportColumns(values[j], ""))
                                fixedColumnCount++;
                            }

                            if (sortedDimensionsList[i] === "zone" && showPlatformColumn) {
                                updatedColumns1.push({
                                    title: "Platform",
                                    dataIndex: "platform",
                                    key: "platform",
                                    width: 150,
                                    sorter: false,
                                    render: (data) => (
                                        <div>
                                            {(data === "" || data === undefined || data === null || data === "-")
                                                ? <div className='text_dark'>-</div>
                                                : <>{data}</>
                                            }
                                        </div>
                                    ),
                                });
                                updatedExportColumns1.push({ label: "Platform", key: "platform", group: "" });
                            }
                        }
                    }

                    for (let i = 0; i < metricsListForCall.length; i++) {
                        if (
                            ConstantMapping.Pixalate_related_keys.includes(metricsListForCall[i])
                        ) {
                            updatedColumns3.push(provideDynamicHeaderColumns(metricsListForCall[i], "", response.data.data.length > 0 ? response.data.dataPartial : false, response.data.data.length > 0 ? response.data.pix_updatedAt : "", ""));

                            updatedExportColumns3.push(provideDynamicExportColumns(metricsListForCall[i], ""))

                        } else {
                            updatedColumns2.push(provideDynamicHeaderColumns(metricsListForCall[i], "", response.data.data.length > 0 ? response.data.dataPartial : false, response.data.data.length > 0 ? response.data.pix_updatedAt : "", ""));

                            updatedExportColumns2.push(provideDynamicExportColumns(metricsListForCall[i], ""))

                        }




                    }

                    setColumnsAll([
                        ...updatedColumns1,
                        ...updatedColumns2,
                        ...(updatedColumns3.length > 0
                            ? [
                                {
                                    title: "Pixalate",
                                    children: updatedColumns3,
                                },
                            ]
                            : []),
                    ])
                    setExportHeader([
                        ...updatedExportColumns1,
                        ...updatedExportColumns2,
                        ...updatedExportColumns3,
                    ])
                    setInitialLoad(false)

                    setTimeout(() => { scrollToItem(tableScrollRef) }, 1000)

                })
                .catch((error) => {

                    let updatedColumns1 = []
                    let updatedColumns2 = []
                    let updatedColumns3 = []
                    let updatedExportColumns1 = []
                    let updatedExportColumns2 = []
                    let updatedExportColumns3 = []
                    let fixedColumnCount = 0;

                    const priorityOrder = ["date", "publisher", "zone"];
                    const sortedDimensionsList = dimensionsList.sort((a, b) => {
                        const indexA = priorityOrder.indexOf(a);
                        const indexB = priorityOrder.indexOf(b);

                        if (indexA === -1 && indexB === -1) return 0; // Both are not in priority list, maintain order
                        if (indexA === -1) return 1; // A is not in priority list, B comes first
                        if (indexB === -1) return -1; // B is not in priority list, A comes first
                        return indexA - indexB; // Sort based on priority order
                    });


                    const showPlatformColumnCatch =
                        (props.role !== "admin" && props.role !== "u_admin") && platformList.length === platformListOptions.length && dimensionsList.includes("zone");

                    for (let i = 0; i < sortedDimensionsList.length; i++) {

                        const values = ConstantMapping.Get_Dimensions_Set[sortedDimensionsList[i]]

                        if (values !== undefined) {
                            for (let j = 0; j < values.length; j++) {
                                updatedColumns1.push(provideDynamicHeaderColumns(values[j], fixedColumnCount, false, "", ""))
                                updatedExportColumns1.push(provideDynamicExportColumns(values[j], ""))
                                fixedColumnCount++;
                            }

                            if (sortedDimensionsList[i] === "zone" && showPlatformColumnCatch) {
                                updatedColumns1.push({
                                    title: "Platform",
                                    dataIndex: "platform",
                                    key: "platform",
                                    width: 150,
                                    sorter: false,
                                    render: (data) => (
                                        <div>
                                            {(data === "" || data === undefined || data === null || data === "-")
                                                ? <div className='text_dark'>-</div>
                                                : <>{data}</>
                                            }
                                        </div>
                                    ),
                                });
                                updatedExportColumns1.push({ label: "Platform", key: "platform", group: "" });
                            }
                        }
                    }

                    for (let i = 0; i < metricsListForCall.length; i++) {

                        if (
                            ConstantMapping.Pixalate_related_keys.includes(metricsListForCall[i])
                        ) {
                            updatedColumns3.push(provideDynamicHeaderColumns(metricsListForCall[i], "", false, "", ""));
                            updatedExportColumns3.push(provideDynamicExportColumns(metricsListForCall[i], ""))

                        } else {
                            updatedColumns2.push(provideDynamicHeaderColumns(metricsListForCall[i], "", false, "", ""));
                            updatedExportColumns2.push(provideDynamicExportColumns(metricsListForCall[i], ""))

                        }



                    }

                    setColumnsAll([
                        ...updatedColumns1,
                        ...updatedColumns2,
                        ...(updatedColumns3.length > 0
                            ? [
                                {
                                    title: "Pixalate",
                                    children: updatedColumns3,
                                },
                            ]
                            : []),
                    ])
                    setExportHeader([
                        ...updatedExportColumns1,
                        ...updatedExportColumns2,
                        ...updatedExportColumns3,
                    ])

                    setData([])
                    setTotalData([])
                    setExportData([])
                    setTotal([])
                    setInitialLoad(false)
                    setErrorScreen(true)

                    if (error?.response) {
                        if (error?.response?.data?.message?.length !== 0) {
                            notifyfailure(error.response.data.message)
                        }
                    } else {
                        notifycatch()
                    }
                });
        }

    }



    const handleExport = (columns, data) => {

        // Step 1: Build group header and column header rows
        const groupHeader = columns.map(col => col.group || "");
        const columnHeader = columns.map(col => col.label);

        // Step 2: Build data rows
        const dataRows = data.map(item =>
            columns.map(col => item[col.key] ?? "")
        );
        // Step 3: Combine into 2D array
        const sheetData = [groupHeader, columnHeader, ...dataRows];

        // Step 4: Create worksheet
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

        // Step 5: Add merged cells for grouped headers
        worksheet["!merges"] = [];

        let colStart = 0;
        while (colStart < columns.length) {
            const group = columns[colStart].group;
            let colEnd = colStart;
            // Find how far the group extends
            while (
                colEnd + 1 < columns.length &&
                columns[colEnd + 1].group === group
            ) {
                colEnd++;
            }

            if (group && colEnd > colStart) {
                worksheet["!merges"].push({
                    s: { r: 0, c: colStart }, // start row 0
                    e: { r: 0, c: colEnd },   // end row 0
                });
            }

            colStart = colEnd + 1;
        }

        // Step 6: Create workbook & export as .xlsx
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
        XLSX.writeFile(workbook, "Report_" + new Date().getTime() + ".xlsx");
    };




    const getDataViaBackend = (dateRange, platformList, countryList, publisherList, zoneList, domainList, mobileList, ctvList, trafficTypeList, deviceTypeList, dimensionsList, search, paginationReload, sortRelated, isExport) => {
        if (isExport !== 1) {
            setBackendLoading(true)
        }
        else {
            setExportBackendLoading(true)
        }


        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {

            let token = Cookies.get("token_xapads_ssp");

            let dataFor = 0;

            let dateRangeCall = {
                startDate: dateRange?.start.format('YYYY-MM-DD'),
                endDate: dateRange?.end.format('YYYY-MM-DD')
            };

            let metricsListForCall = ["pub_requests", "pub_response", "pub_coverage_rate", "pub_gross_impressions", "pub_win_rate", "pub_gross_clicks", "pub_ctr", "pub_fill_rate"]
            const visibleMetrics = Object.keys(colvis).length > 0
                ? metricsListForCall.filter(m => colvis[m] !== false)
                : metricsListForCall;

            if (platformList.length === 1) {
                if (platformList[0] === "Adkernel") {
                    dataFor = 1
                }
                else {
                    dataFor = 3
                }
            }


            if (isExport !== 1) {

                setTileRequests(null)
                setTileImpressions(null)
                setTileBids(null)
                setTileClicks(null)

                let filter = {
                    "dataFor": dataFor,
                    "country": countryList,
                    "publisher_ids": publisherList,
                    "zone_ids": zoneList,
                    "site_domain": domainList,
                    "mobile_app": mobileList,
                    "ctv_app": ctvList,
                    "traffic_type": trafficTypeList,
                    "format_type": deviceTypeList,
                    // "dimensions": dimensionsList.length === 0 ? ["publisher"] : dimensionsList,
                    "dimensions": dimensionsList,
                    "metrics": metricsListForCall,
                    "search": search,
                    "tab": "demand",
                    "pagination": { "page": paginationReload === 1 ? 1 : page.current, "limit": page.pageSize }, "sort": { "field": sortRelated.name, "ord": sortRelated.type }
                }


                axios.post(configData.SERVER_URL + `pubReport/`, {
                    "filter": filter,
                    "date": dateRangeCall,
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                    .then((response) => {

                        if (response.data.data && response.data.data.length > 0) {

                            let tempPage = { ...page }
                            if (paginationReload === 1) {
                                tempPage.current = 1
                            }
                            tempPage.total = response.data.totalRecords
                            setTotalAdkRecords(response.data.adkTotalRecords)
                            setPage(tempPage)

                            setTotalData(response.data.data)
                            setTotal(response.data.total)
                            setData(response.data.data);

                            //export Logic
                            let tempData = [...response.data.data];
                            let tempTotal = { ...response.data.total }; // Spread existing properties
                            let totalKey
                            if (!dimensionsList?.length) {
                                totalKey = null; // or return early

                            } else {
                                totalKey = ConstantMapping.Get_Dimensions_Set[dimensionsList[0]]?.[0] ?? null;

                            }

                            if (dimensionsList.length === 0) {
                                tempTotal["publisher"] = "Total";
                            }
                            else {
                                tempTotal[totalKey] = "Total";
                            }

                            tempData.push(tempTotal); // Append the updated object to the array
                            setExportData(tempData);
                            setErrorScreen(false)

                            setTileRequests(response.data.total.pub_requests)
                            setTileImpressions(response.data.total.pub_gross_impressions)
                            // setTileBids(response.data.data.total.pub_requests)
                            setTileClicks(response.data.total.pub_gross_clicks)

                        }
                        else {
                            let tempPage = { ...page }
                            tempPage.current = 1
                            tempPage.total = 0
                            setPage(tempPage)
                            setTotalData([])
                            setTotal([])
                            setData([])
                            setExportData([])
                            setErrorScreen(false)


                        }



                        let updatedColumns1 = []
                        let updatedColumns2 = []
                        let updatedColumns3 = []
                        let updatedExportColumns1 = []
                        let updatedExportColumns2 = []
                        let updatedExportColumns3 = []
                        let fixedColumnCount = 0;


                        // ----------------------------------------
                        const priorityOrder = ["date", "publisher", "zone"];
                        let sortedDimensionsList = dimensionsList.sort((a, b) => {
                            const indexA = priorityOrder.indexOf(a);
                            const indexB = priorityOrder.indexOf(b);

                            if (indexA === -1 && indexB === -1) return 0;
                            if (indexA === -1) return 1;
                            if (indexB === -1) return -1;
                            return indexA - indexB;
                        });

                        if (dimensionsList.length === 0) {
                            sortedDimensionsList = ["publisher"]
                        }


                        //------------------------------------------

                        // for (let i = 0; i < sortedDimensionsList.length; i++) {

                        //     const values = ConstantMapping.Get_Dimensions_Set[sortedDimensionsList[i]]

                        //     if (values !== undefined) {
                        //         for (let i = 0; i < values.length; i++) {
                        //             updatedColumns1.push(provideDynamicHeaderColumns(values[i], fixedColumnCount, false, "", "backend"))
                        //             updatedExportColumns1.push(provideDynamicExportColumns(values[i], ""))
                        //             fixedColumnCount++;
                        //         }


                        //     }
                        // }

                        const firstRow = response?.data?.data?.[0] || {};

                        const showPlatformColumn =
                            (props.role !== "admin" && props.role !== "u_admin") && platformList.length === platformListOptions.length && dimensionsList.includes("zone");

                        for (let i = 0; i < sortedDimensionsList.length; i++) {

                            const dimension = sortedDimensionsList[i];
                            const values = ConstantMapping.Get_Dimensions_Set[dimension];

                            if (!values) continue;

                            // Filter only fields that exist in response
                            const validFields = values.filter(field => field in firstRow);

                            // If no fields exist → skip dimension
                            if (validFields.length === 0) continue;

                            for (let j = 0; j < validFields.length; j++) {

                                updatedColumns1.push(
                                    provideDynamicHeaderColumns(validFields[j], fixedColumnCount, false, "", "backend")
                                );

                                updatedExportColumns1.push(
                                    provideDynamicExportColumns(validFields[j], "")
                                );

                                fixedColumnCount++;
                            }

                            if (dimension === "zone" && showPlatformColumn) {
                                updatedColumns1.push({
                                    title: "Platform",
                                    dataIndex: "platform",
                                    key: "platform",
                                    width: 150,
                                    sorter: false,
                                    render: (data) => (
                                        <div>
                                            {(data === "" || data === undefined || data === null || data === "-")
                                                ? <div className='text_dark'>-</div>
                                                : <>{data}</>
                                            }
                                        </div>
                                    ),
                                });
                                updatedExportColumns1.push({ label: "Platform", key: "platform", group: "" });
                            }
                        }


                        const restrictedMetrics = [
                            "pub_requests",
                            "pub_response",
                            "pub_gross_impressions",
                            "pub_gross_clicks",
                            "pub_ctr",
                            "pub_fill_rate",
                            "pub_coverage_rate",
                            "pub_win_rate"
                        ];

                        // const firstRow = response?.data?.data?.[0] || {};

                        const metricsToUse = metricsListForCall.filter(metric => {
                            // If metric is in restricted list AND not present in response first object → remove it
                            if (restrictedMetrics.includes(metric) && !(metric in firstRow)) {
                                return false;
                            }
                            return true;
                        });



                        for (let i = 0; i < metricsToUse.length; i++) {

                            if (
                                ConstantMapping.Pixalate_related_keys.includes(metricsToUse[i])
                            ) {
                                updatedColumns3.push(provideDynamicHeaderColumns(metricsToUse[i], "", response.data.data.length > 0 ? response.data.dataPartial : false, response.data.data.length > 0 ? response.data.pix_updatedAt : "", "backend"));

                                updatedExportColumns3.push(provideDynamicExportColumns(metricsToUse[i], ""))
                            } else {
                                updatedColumns2.push(provideDynamicHeaderColumns(metricsToUse[i], "", response.data.data.length > 0 ? response.data.dataPartial : false, response.data.data.length > 0 ? response.data.pix_updatedAt : "", "backend"));

                                updatedExportColumns2.push(provideDynamicExportColumns(metricsToUse[i], ""))
                            }


                        }

                        setColumnsAll([
                            ...updatedColumns1,
                            ...updatedColumns2,
                            ...(updatedColumns3.length > 0
                                ? [
                                    {
                                        title: "Pixalate",
                                        children: updatedColumns3,
                                    },
                                ]
                                : []),
                        ])

                        setExportHeader([
                            ...updatedExportColumns1,
                            ...updatedExportColumns2,
                            ...updatedExportColumns3,
                        ])

                        if (isGenerateCallRef.current) {
                            const newColvis = {};
                            const newColvisOptions = [];
                            metricsToUse.forEach(m => {
                                newColvis[m] = true;
                                newColvisOptions.push({ label: ConstantMapping.Get_Labels_Metrics[m] || m, value: m });
                            });
                            setColvis(newColvis);
                            setColvisOptions(newColvisOptions);
                            isGenerateCallRef.current = false;
                        }

                        setInitialLoad(false)
                        setBackendLoading(false)

                        setTimeout(() => { scrollToItem(tableScrollRef) }, 1000)

                    })
                    .catch((error) => {


                        let updatedColumns1 = []
                        let updatedColumns2 = []
                        let updatedColumns3 = []
                        let updatedExportColumns1 = []
                        let updatedExportColumns2 = []
                        let updatedExportColumns3 = []
                        let fixedColumnCount = 0;

                        const priorityOrder = ["date", "publisher", "zone"];
                        const sortedDimensionsList = dimensionsList.sort((a, b) => {
                            const indexA = priorityOrder.indexOf(a);
                            const indexB = priorityOrder.indexOf(b);

                            if (indexA === -1 && indexB === -1) return 0; // Both are not in priority list, maintain order
                            if (indexA === -1) return 1; // A is not in priority list, B comes first
                            if (indexB === -1) return -1; // B is not in priority list, A comes first
                            return indexA - indexB; // Sort based on priority order
                        });


                        const showPlatformColumnCatch =
                            (props.role !== "admin" && props.role !== "u_admin") && platformList.length === platformListOptions.length && dimensionsList.includes("zone");

                        for (let i = 0; i < sortedDimensionsList.length; i++) {

                            const values = ConstantMapping.Get_Dimensions_Set[sortedDimensionsList[i]]

                            if (values !== undefined) {
                                for (let j = 0; j < values.length; j++) {
                                    updatedColumns1.push(provideDynamicHeaderColumns(values[j], fixedColumnCount, false, "", "backend"))
                                    updatedExportColumns1.push(provideDynamicExportColumns(values[j], ""))
                                    fixedColumnCount++;
                                }

                                if (sortedDimensionsList[i] === "zone" && showPlatformColumnCatch) {
                                    updatedColumns1.push({
                                        title: "Platform",
                                        dataIndex: "platform",
                                        key: "platform",
                                        width: 150,
                                        sorter: false,
                                        render: (data) => (
                                            <div>
                                                {(data === "" || data === undefined || data === null || data === "-")
                                                    ? <div className='text_dark'>-</div>
                                                    : <>{data}</>
                                                }
                                            </div>
                                        ),
                                    });
                                    updatedExportColumns1.push({ label: "Platform", key: "platform", group: "" });
                                }
                            }
                        }


                        for (let i = 0; i < metricsListForCall.length; i++) {
                            if (
                                ConstantMapping.Pixalate_related_keys.includes(metricsListForCall[i])
                            ) {
                                updatedColumns3.push(provideDynamicHeaderColumns(metricsListForCall[i], "", false, "", "backend"));
                                updatedExportColumns3.push(provideDynamicExportColumns(metricsListForCall[i], ""))
                            } else {
                                updatedColumns2.push(provideDynamicHeaderColumns(metricsListForCall[i], "", false, "", "backend"));
                                updatedExportColumns2.push(provideDynamicExportColumns(metricsListForCall[i], ""))
                            }

                        }

                        setColumnsAll([
                            ...updatedColumns1,
                            ...updatedColumns2,
                            ...(updatedColumns3.length > 0
                                ? [
                                    {
                                        title: "Pixalate",
                                        children: updatedColumns3,
                                    },
                                ]
                                : []),
                        ])
                        setExportHeader([
                            ...updatedExportColumns1,
                            ...updatedExportColumns2,
                            ...updatedExportColumns3,
                        ])

                        setData([])
                        setTotalData([])
                        setExportData([])
                        setTotal([])
                        setInitialLoad(false)
                        setErrorScreen(true)
                        setBackendLoading(false)



                        if (error?.response) {
                            if (error?.response?.data?.message?.length !== 0) {
                                notifyfailure(error.response.data.message)
                            }
                        } else {
                            console.log(error)
                            notifycatch()
                        }
                    });
            }
            else {

                let filter = {
                    "dataFor": dataFor,
                    "country": countryList,
                    "publisher_ids": publisherList,
                    "zone_ids": zoneList,
                    "site_domain": domainList,
                    "mobile_app": mobileList,
                    "ctv_app": ctvList,
                    "traffic_type": trafficTypeList,
                    "format_type": deviceTypeList,
                    "dimensions": dimensionsList,
                    "metrics": visibleMetrics,
                    "search": search,
                    "tab": "demand",
                    "pagination": { "page": page.current, "limit": page.pageSize }, "sort": { "field": sortRelated.name, "ord": sortRelated.type },
                }


                axios.post(configData.SERVER_URL + `pubReport/`, {
                    "filter": filter,
                    "export": 1,
                    "date": dateRangeCall,
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                    responseType: "blob",
                })
                    .then((response) => {
                        if (response.data) {
                            const blob = new Blob([response.data], {
                                // type: "text/plain;charset=utf-8",
                                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            });
                            saveAs(blob, "Report_" + new Date().getTime() + ".xlsx");
                        }

                        setExportBackendLoading(false)


                    })
                    .catch(async (e) => {
                        if (axios.isAxiosError(e) && e.response?.data) {
                            const d = e.response.data;
                            const text =
                                typeof d === "string"
                                    ? d
                                    : d instanceof Blob
                                        ? await d.text()
                                        : null;
                            const payload =
                                text != null
                                    ? (() => {
                                        try {
                                            return JSON.parse(text);
                                        } catch {
                                            return null;
                                        }
                                    })()
                                    : d;
                            const errMsg = payload?.error ?? payload?.message ?? e.message;
                            notifyfailure(errMsg)
                        }
                        else {
                            notifycatch();
                        }
                        setExportBackendLoading(false)
                    });
                // .catch((error) => {
                //     if (error?.response) {
                //         if (error?.response?.data?.message?.length !== 0) {
                //             notifyfailure(error.response.data.message)
                //         }
                //     } else {
                //         notifycatch()
                //     }
                //     setExportBackendLoading(false)
                // });
            }
        }

    }

    function provideDynamicHeaderColumns(dataColumn, type, partial, columnTimeData, callFrom) {
        let returnData = {}

        //---dimension columns

        if (dataColumn === "publisher_id" || dataColumn === "zone_id") {

            returnData = {
                title: ConstantMapping.Get_Labels_Dimensions[dataColumn],
                dataIndex: dataColumn,
                width: 120,
                key: dataColumn,
                sorter: true,
                sortDirections: ['ascend', 'descend', 'ascend'],
                render: (data, record) => {
                    return (
                        <div >
                            {(data === "" || data === undefined || data === null || data === "-") ?
                                <>
                                    <div className='text_dark'>-</div>
                                </>
                                :
                                <>
                                    {data}
                                </>

                            }
                        </div>
                    )
                },


            }

            if (dataColumn === "publisher_id") {
                returnData.fixed = 'left'
            }
        }
        if (dataColumn === "publisher" || dataColumn === "zone" || dataColumn === "date" || dataColumn === "country" || dataColumn === "traffic_type" || dataColumn === "format_type" || dataColumn === "site_domain" || dataColumn === "app_bundle" || dataColumn === "dsp_adomain" || dataColumn === "dsp_seat" || dataColumn === "device_type" || dataColumn === "remotefeed_provider") {
            returnData = {
                title: ConstantMapping.Get_Labels_Dimensions[dataColumn],
                dataIndex: dataColumn,
                width: 150,
                key: dataColumn,
                sorter: (callFrom === "backend" && (dataColumn === "traffic_type" || dataColumn === "format_type" || dataColumn === "site_domain" || dataColumn === "app_bundle")) ? false : true,
                sortDirections: ['ascend', 'descend', 'ascend'],
                render: (data, record) => {
                    return (
                        <div >
                            {(data === "" || data === undefined || data === null || data === "-") ?
                                <>
                                    <div className='text_dark'>-</div>
                                </>
                                :
                                <>
                                    {dataColumn === "country" ?
                                        <>

                                            {data?.length > 20 ? (
                                                <Tooltip title={data}>
                                                    {data.slice(0, 20)} ...
                                                </Tooltip>
                                            ) : (
                                                <>{data}</>
                                            )}
                                        </>
                                        :
                                        dataColumn === "site_domain" || dataColumn === "app_bundle" ?
                                            <>

                                                {data?.length > 35 ? (
                                                    <Tooltip title={data}>
                                                        {data.slice(0, 35)} ...
                                                    </Tooltip>
                                                ) : (
                                                    <>{data}</>
                                                )}
                                            </>
                                            :
                                            dataColumn === "traffic_type" ?
                                                <div style={{ textTransform: "lowercase" }}>
                                                    {data}
                                                </div>
                                                :
                                                <>
                                                    {data}
                                                </>
                                    }

                                </>

                            }
                        </div>
                    )
                },

            }

            if (dataColumn === "publisher" || dataColumn === "date") {
                returnData.fixed = 'left'
            }
        }

        //----number columns
        if (dataColumn === "pub_response" || dataColumn === "pub_gross_impressions" || dataColumn === "pub_gross_clicks") {
            returnData = {
                title:
                    <>
                        {
                            (dataColumn === "remotefeed_requests" || dataColumn === "pub_response" || dataColumn === "pub_gross_impressions" || dataColumn === "pub_gross_clicks" || dataColumn === "pub_requests" || dataColumn === "pub_bid") ?
                                <span >
                                    {ConstantMapping.Get_Labels_Metrics[dataColumn]}

                                </span> :
                                <>

                                    <span >
                                        {ConstantMapping.Get_Labels_Metrics[dataColumn]}
                                        {partial ?
                                            <Tooltip
                                                title={`Partial Data (${columnTimeData})`}
                                            >
                                                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                                            </Tooltip>
                                            :
                                            <Tooltip
                                                title={`Complete Data (${columnTimeData})`}
                                            >
                                                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                                            </Tooltip>
                                        }
                                    </span>

                                </>
                        }
                    </>,
                dataIndex: dataColumn,
                width: dataColumn === "givtSivtImp" ? 100 : 150,
                key: dataColumn,
                sorter: (callFrom === "backend" && (dataColumn === "impressions" || dataColumn === "givtImpressions" || dataColumn === "sivtImpressions" || dataColumn === "givtSivtImp")) ? false : true,
                sortDirections: ['ascend', 'descend', 'ascend'],
                render: (data, record) => {
                    return (
                        <>
                            {(data === "" || data === undefined || data === null || data === "-") ?
                                <>
                                    <div className='text_dark'>-</div>
                                </>
                                :
                                <>
                                    {addCommasToNumber(data)}
                                </>
                            }
                        </>
                    )

                },

            }
        }

        if (dataColumn === "remotefeed_requests" || dataColumn === "pub_requests" || dataColumn === "pub_bid" || dataColumn === "impressions" || dataColumn === "givtImpressions" || dataColumn === "sivtImpressions" || dataColumn === "givtSivtImp") {
            returnData = {
                title:
                    <>
                        {
                            (dataColumn === "remotefeed_requests" || dataColumn === "pub_response" || dataColumn === "pub_gross_impressions" || dataColumn === "pub_gross_clicks" || dataColumn === "pub_requests" || dataColumn === "pub_bid") ?
                                <span >
                                    {ConstantMapping.Get_Labels_Metrics[dataColumn]}
                                    <Tooltip
                                        title={dataColumn === "remotefeed_requests" ? "R Requests" :
                                            dataColumn === "pub_response" ? "Responses" :
                                                dataColumn === "pub_gross_impressions" ? "Net Impressions" :
                                                    dataColumn === "pub_gross_clicks" ? "Clicks" :
                                                        dataColumn === "pub_requests" ? "Outgoing Request" :
                                                            "Bid Responses"
                                        }
                                    >
                                        <img src={reportInfo} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                                    </Tooltip>
                                </span> :
                                <>

                                    <span >
                                        {ConstantMapping.Get_Labels_Metrics[dataColumn]}
                                        {partial ?
                                            <Tooltip
                                                title={`Partial Data (${columnTimeData})`}
                                            >
                                                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                                            </Tooltip>
                                            :
                                            <Tooltip
                                                title={`Complete Data (${columnTimeData})`}
                                            >
                                                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                                            </Tooltip>
                                        }
                                    </span>

                                </>
                        }
                    </>,
                dataIndex: dataColumn,
                width: dataColumn === "givtSivtImp" ? 100 : 150,
                key: dataColumn,
                sorter: (callFrom === "backend" && (dataColumn === "impressions" || dataColumn === "givtImpressions" || dataColumn === "sivtImpressions" || dataColumn === "givtSivtImp")) ? false : true,
                sortDirections: ['ascend', 'descend', 'ascend'],
                render: (data, record) => {
                    return (
                        <>
                            {(data === "" || data === undefined || data === null || data === "-") ?
                                <>
                                    <div className='text_dark'>-</div>
                                </>
                                :
                                <>
                                    {addCommasToNumber(data)}
                                </>
                            }
                        </>
                    )

                },

            }
        }

        //---- % rate columns

        if (dataColumn === "pub_fill_rate" || dataColumn === "pub_coverage_rate" || dataColumn === "pub_win_rate" || dataColumn === "pub_ctr" || dataColumn === "givtImpsRate" || dataColumn === "sivtImpsRate" || dataColumn === "viewability" || dataColumn === "givtSivtRate" || dataColumn === "pub_new_coverage") {
            returnData = {
                title:
                    <>
                        {
                            (dataColumn === "pub_fill_rate" || dataColumn === "pub_coverage_rate" || dataColumn === "pub_win_rate" || dataColumn === "pub_ctr" || dataColumn === "pub_new_coverage") ?
                                <span >
                                    {ConstantMapping.Get_Labels_Metrics[dataColumn]}
                                    <Tooltip title={dataColumn === "pub_fill_rate" ? "(Impressions / Requests) * 100" :
                                        dataColumn === "pub_coverage_rate" ? "(Response / Requests) * 100" :
                                            dataColumn === "pub_win_rate" ? "(Impressions / Response) * 100" :
                                                dataColumn === "pub_new_coverage" ? "(Bids / Inventory) * 100" :
                                                    "(Clicks / Impressions) * 100"
                                    }
                                    >
                                        <img src={reportInfo} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                                    </Tooltip>
                                </span> :
                                <>

                                    <span >
                                        {ConstantMapping.Get_Labels_Metrics[dataColumn]}
                                        {partial ?
                                            <Tooltip
                                                title={`Partial Data (${columnTimeData})`}
                                            >
                                                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                                            </Tooltip>
                                            :
                                            <Tooltip
                                                title={`Complete Data (${columnTimeData})`}
                                            >
                                                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                                            </Tooltip>
                                        }
                                    </span>

                                </>
                        }
                    </>
                ,
                dataIndex: dataColumn,
                width: dataColumn === "viewability" ? 170 : (dataColumn === "pub_new_coverage" || dataColumn === "pub_coverage_rate" || dataColumn === "pub_win_rate") ? 150 : 120,
                key: dataColumn,
                sorter: callFrom === "backend" ? false : true,
                sortDirections: ['ascend', 'descend', 'ascend'],
                render: (data, record) => {
                    return (
                        <>
                            {(data === undefined || data === "" || data === null || data === "-") ?
                                <>
                                    <div className='text_dark'>-</div>
                                </>
                                :
                                <>
                                    {data} %
                                </>
                            }
                        </>
                    )

                },

            }
        }

        //---- $ amount columns

        if (dataColumn === "pub_revenue" || dataColumn === "pub_total_cost" || dataColumn === "profit" || dataColumn === "pub_net_ecpm" || dataColumn === "pub_rpm" || dataColumn === "pub_avg_bidfloor") {
            returnData = {
                title: <span >
                    {ConstantMapping.Get_Labels_Metrics[dataColumn]}
                    <Tooltip title={dataColumn === "pub_revenue" ? "R Revenue" :
                        dataColumn === "pub_total_cost" ? "Net Revenue" :
                            dataColumn === "profit" ? "Revenue - Total Cost" :
                                dataColumn === "pub_net_ecpm" ? " (Total cost/ Impressions) * 1000" :
                                    dataColumn === "pub_avg_bidfloor" ? "Floor" :
                                        "(Total Cost/ Inventory) * 1000000"
                    }>
                        <img src={reportInfo} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                    </Tooltip>
                </span>,
                dataIndex: dataColumn,
                width: 150,
                key: dataColumn,
                sorter: (callFrom === "backend" && (dataColumn === "profit" || dataColumn === "pub_net_ecpm" || dataColumn === "pub_rpm" || dataColumn === "pub_avg_bidfloor")) ? false : true,
                sortDirections: ['ascend', 'descend', 'ascend'],
                render: (data, record) => {
                    return (
                        <>
                            {(data === "" || data === undefined || data === null || data === "-") ?
                                <>
                                    <div className='text_dark'>-</div>
                                </>
                                :
                                <>
                                    $ {addCommasToNumber(data)}
                                </>

                            }
                        </>
                    )

                },
            }
        }

        //pixlate related Data-------------------------------
        if (dataColumn === "discrep") {
            returnData = {
                title:
                    <>

                        <span >
                            {ConstantMapping.Get_Labels_Metrics[dataColumn]}
                            {partial ?
                                <Tooltip
                                    title={`Partial Data (${columnTimeData}) (Gross Ad Count/Impressions)*100`}
                                >
                                    <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                                </Tooltip>
                                :
                                <Tooltip
                                    title={`Complete Data (${columnTimeData}) (Gross Ad Count/Impressions)*100`}
                                >
                                    <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                                </Tooltip>
                            }
                        </span>

                    </>,
                dataIndex: dataColumn,
                width: 165,
                key: dataColumn,
                sorter: callFrom === "backend" ? false : true,
                sortDirections: ['ascend', 'descend', 'ascend'],
                render: (data, record) => {
                    return (
                        <>
                            {(data === "" || data === undefined || data === null || data === "-") ?
                                <>
                                    <div className='text_dark'>-</div>
                                </>
                                :
                                <>
                                    <span style={{ color: data.split(" ")[0] === "Low" ? "#0C875E" : data.split(" ")[0] === "High" ? "#FF0000" : "#EBB200" }}>{data.split(" ")[0]}</span>  <span style={{ color: "#475467" }}>{data.split(" ")[1]}</span>
                                </>
                            }
                        </>
                    )
                },

            }
        }

        return returnData
    }

    function provideDynamicExportColumns(data, type) {
        const isPixalate = ConstantMapping.Pixalate_related_keys.includes(data);
        const groupingValue = isPixalate ? "Pixalate" : "";

        if (data === "publisher_id" || data === "zone_id") {
            return { label: ConstantMapping.Get_Labels_Dimensions[data], key: data, group: groupingValue }
        }
        if (data === "publisher" || data === "zone" || data === "date" || data === "country" || data === "traffic_type" || data === "format_type" || data === "site_domain" || data === "app_bundle" || data === "dsp_adomain" || data === "device_type" || data === "remotefeed_provider") {
            return { label: ConstantMapping.Get_Labels_Dimensions[data], key: data, group: groupingValue }
        }
        return { label: ConstantMapping.Get_Labels_Metrics[data], key: data, group: groupingValue }
    }

    useEffect(() => {
        if (!initialLoad) {
            const delayDebounceFn = setTimeout(() => {
                setPage(prev => ({ ...prev, current: 1 }));
                // if (search.length === 0 && paginationProcess === "backend") {
                getDataViaBackend(dateRangePreviousApplied, platformListPreviousApplied, countryListPreviousApplied, publisherListPreviousApplied, zoneListPreviousApplied, domainListPreviousApplied, mobileListPreviousApplied, ctvListPreviousApplied, trafficTypeListPreviousApplied, deviceTypeListPreviousApplied, dimensionsListPreviousApplied, search, 1, sortObject, "")
                // }
                // else {
                //     paginateArray(totalData, tempPage.current, page.pageSize, search, sortObject.name, sortObject.type)
                // }
            }, 700); // 500ms delay
            // Cleanup function to clear the timeout if query changes
            return () => clearTimeout(delayDebounceFn);
        }
    }, [search]);


    const handleTableChange = (pagination, filters, sorter) => {
        setSortObject({ name: sorter.field, type: sorter.order === "ascend" ? 1 : -1 });

        if (paginationProcess === "backend") {
            getDataViaBackend(dateRangePreviousApplied, platformListPreviousApplied, countryListPreviousApplied, publisherListPreviousApplied, zoneListPreviousApplied, domainListPreviousApplied, mobileListPreviousApplied, ctvListPreviousApplied, trafficTypeListPreviousApplied, deviceTypeListPreviousApplied, dimensionsListPreviousApplied, search, "", { name: sorter.field, type: sorter.order === "ascend" ? 1 : -1 }, "")
        }
        else {
            paginateArray(totalData, page.current, page.pageSize, search, sorter.field, sorter.order === "ascend" ? 1 : -1)
        }

    };


    const handlePageChange = (data) => {

        let tempPage = page
        tempPage.current = data
        setPage(tempPage);


        if (paginationProcess === "backend") {
            getDataViaBackend(dateRangePreviousApplied, platformListPreviousApplied, countryListPreviousApplied, publisherListPreviousApplied, zoneListPreviousApplied, domainListPreviousApplied, mobileListPreviousApplied, ctvListPreviousApplied, trafficTypeListPreviousApplied, deviceTypeListPreviousApplied, dimensionsListPreviousApplied, search, "", sortObject, "")
        }
        else {
            paginateArray(totalData, tempPage.current, page.pageSize, search, sortObject.name, sortObject.type)
        }

    };

    const handlePageSizeChange = (e) => {
        let tempPage = page
        tempPage.pageSize = e

        if (tempPage.current > 1) {
            if (e * tempPage.current > tempPage.total) {
                tempPage.current = 1
            }
        }
        setPage(tempPage);

        if (paginationProcess === "backend") {
            getDataViaBackend(dateRangePreviousApplied, platformListPreviousApplied, countryListPreviousApplied, publisherListPreviousApplied, zoneListPreviousApplied, domainListPreviousApplied, mobileListPreviousApplied, ctvListPreviousApplied, trafficTypeListPreviousApplied, deviceTypeListPreviousApplied, dimensionsListPreviousApplied, search, "", sortObject, "")
        }
        else {
            paginateArray(totalData, tempPage.current, tempPage.pageSize, search, sortObject.name, sortObject.type)
        }
    };


    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };

    const locale = {
        emptyText:
            <>{
                errorScreen ?
                    <div className='no_data_screen'>
                        <div className='text-center'>
                            <img src={error2Data} className='' alt="" />
                            <div className='float_text_div'>
                            </div>
                        </div>
                    </div>
                    :
                    search.trim().length > 0 && backendLoading ?
                        <div className='no_data_screen'>
                            <div className='text-center'>
                                <div className='float_text_div'>
                                </div>
                            </div>
                        </div>
                        :
                        search.trim().length > 0 && !backendLoading ?
                            <div className='no_data_screen'>
                                <div className='text-center'>
                                    <img src={errorData} className='' alt="" />
                                    <div className='float_text_div'>
                                    </div>
                                </div>
                            </div>
                            :
                            backendLoading ?
                                <div className='no_data_screen'>
                                    <div className='text-center'>
                                        <div className='float_text_div'>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className='no_data_screen' >
                                    <div className='text-center'>
                                        <img src={noData} className='' alt="" />
                                        <div className='float_text_div'>
                                        </div>
                                    </div>
                                </div>
            }
            </>

    };


    ///////////////////////////////extra code starts//////////////////////////

    const containerRef = useRef(null);
    const [openSelectState, setOpenSelectState] = useState({});

    const debounce = (func, delay) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    };
    // Handle scroll to close all Select dropdowns
    useEffect(() => {
        const handleScroll = () => {
            if (Object.values(openSelectState).some((isOpen) => isOpen)) {
                setOpenSelectState({}); // Close all open dropdowns
            }
            const cancelBtn = document.querySelector(".daterangepicker .applyBtn"); // Select the cancel button
            if (cancelBtn) {
                cancelBtn.click(); // Simulate a click on the Cancel button
            }
        };

        const debouncedHandleScroll = debounce(handleScroll, 50); // Debounce for smoothness

        const currentDiv = containerRef.current;
        if (currentDiv) {
            currentDiv.addEventListener('scroll', debouncedHandleScroll);
        }


        return () => {
            if (currentDiv) {
                currentDiv.removeEventListener('scroll', debouncedHandleScroll);
            }
        };

    }, [openSelectState]);

    const toggleSelectOpen = (key, open) => {
        setOpenSelectState((prevState) => {
            if (prevState[key] === open) return prevState; // Avoid unnecessary updates
            return { ...prevState, [key]: open };
        });
        if (open) {
            setTimeout(() => {
                refsMap.current[key]?.current?.focus();
            }, 500);
        }
    };

    const refsMap = useRef({});
    function getRef(key) {
        if (!refsMap.current[key]) {
            refsMap.current[key] = React.createRef();
        }
        return refsMap.current[key];
    }

    // Focus is handled in toggleSelectOpen: when open=true, calls refsMap.current[key]?.current?.focus() after 50ms.

    // Inject live sortOrder into columns so Ant Design shows the correct sort icon
    const columnsWithSortOrder = columnsAll.map((col) => {
        if (col.children) {
            return {
                ...col,
                children: col.children.map((child) => ({
                    ...child,
                    sortOrder: sortObject.name === child.key
                        ? (sortObject.type === -1 ? 'descend' : 'ascend')
                        : null,
                })),
            };
        }
        return {
            ...col,
            sortOrder: sortObject.name === col.key
                ? (sortObject.type === -1 ? 'descend' : 'ascend')
                : null,
        };
    });

    const visibleColumnsWithSortOrder = Object.keys(colvis).length === 0
        ? columnsWithSortOrder
        : columnsWithSortOrder.map(col => {
            if (col.children) {
                const visibleChildren = col.children.filter(c => colvis[c.key] !== false);
                return { ...col, children: visibleChildren, hidden: visibleChildren.length === 0 };
            }
            if (colvis.hasOwnProperty(col.key)) {
                return { ...col, hidden: !colvis[col.key] };
            }
            return col;
        });

    const isColvisIndeterminate = colvisOptions.length > 0 &&
        colvisOptions.some(opt => colvis[opt.value] === false) &&
        !colvisOptions.every(opt => colvis[opt.value] === false);
    const isColvisAllChecked = colvisOptions.length > 0 && colvisOptions.every(opt => colvis[opt.value] !== false);

    const [isColumnsDropdownOpen, setIsColumnsDropdownOpen] = useState(false);


    return (
        <>


            {!pageLoad ?
                <>
                    <div className='filter_content_block --clear_all_text_shift'>
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>

                                <Row gutter={[12, 20]} className="five-col-row">
                                    <Col>
                                        <div className="form_group">
                                            <label className='form_label'>Interval</label>
                                            <div className='form_content_block--group form_select_datepicker'>
                                                <DateRangePicker
                                                    key={pickerKey}
                                                    ref={datepickerRef}
                                                    startDate={dateRange.start}
                                                    endDate={dateRange.end}
                                                    onShow={(event, picker) => {
                                                        picker.container.addClass("textclass");
                                                    }}
                                                    initialSettings={{
                                                        containerClass: "custom-class-1",
                                                        alwaysShowCalendars: true,
                                                        startDate: dateRange.start,
                                                        endDate: dateRange.end,
                                                        locale: {
                                                            format: "DD/MM/YYYY",
                                                        },
                                                        minDate: moment("2026-02-01").toDate(),
                                                        // maxDate is PST today — future local dates are disabled
                                                        maxDate: pstToday.clone().toDate(),
                                                        maxSpan: { days: 30 },
                                                        ranges: {
                                                            // "Today" = PST today (e.g. 24th even if local shows 25th)
                                                            Today: [pstToday.clone().toDate(), pstToday.clone().toDate()],
                                                            // "Yesterday" = one day before PST today
                                                            Yesterday: [pstYesterday.clone().toDate(), pstYesterday.clone().toDate()],
                                                            'Last 7 Days': [
                                                                pstToday.clone().subtract(6, 'days').toDate(),
                                                                pstToday.clone().toDate(),
                                                            ],
                                                            'Last 30 Days': [
                                                                pstToday.clone().subtract(29, 'days').toDate(),
                                                                pstToday.clone().toDate(),
                                                            ],
                                                            'This Month': [
                                                                pstToday.clone().startOf('month').toDate(),
                                                                pstToday.clone().toDate(),
                                                            ],
                                                            'Last Month': [
                                                                pstToday.clone().subtract(1, 'month').startOf('month').toDate(),
                                                                pstToday.clone().subtract(1, 'month').endOf('month').startOf('day').toDate(),
                                                            ],
                                                        },
                                                    }}

                                                    onCallback={(start, end, label) => {
                                                        const diffDays = moment(end).diff(moment(start), "days");
                                                        // if (label === "Custom Range" && diffDays > 31) {
                                                        //     notifyfailure("Custom range cannot be greater than 31 days!");
                                                        // } 

                                                        // else {
                                                        setDateRange({ start: start, end: end });
                                                        setLabelName(label)

                                                        // }
                                                    }
                                                    }
                                                >
                                                    <div id="reportrange"
                                                        className={hasClass ? "form_select --daterangepicker active" : "form_select --daterangepicker"}
                                                    >
                                                        {/* <span className="pl_10">{labelName === "Custom Range" ? label : labelName}</span> */}
                                                        <span className="text_label">
                                                            {/* {label} */}
                                                            {dateRange.start.format('DD MMM YYYY')} - {dateRange.end.format('DD MMM YYYY')}
                                                        </span>
                                                        <i className="fa fa-caret-down"></i>
                                                    </div>
                                                </DateRangePicker>
                                            </div>
                                        </div>

                                    </Col>
                                    {(props.role !== "admin" && props.role !== "u_admin") &&
                                        <Col>
                                            <div className="form_group form_select_multiple_group">
                                                <label className='form_label'>Platform
                                                    {platformList.length > 0 &&
                                                        <span className="clear_all"
                                                            onClick={() => {
                                                                setPlatformList([]);
                                                            }}
                                                        >
                                                            Clear all
                                                        </span>
                                                    }
                                                </label>
                                                <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100 form_content_block--group">
                                                    <Select
                                                        value={platformList}
                                                        popupClassName='diff_select_d2 form_select_multiple--dropdown'
                                                        maxTagCount={1}
                                                        showSearch={false}
                                                        placeholder='- Select -'
                                                        maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
                                                        className="form_select_multiple"
                                                        mode='multiple'
                                                        onChange={(event) => {
                                                            setPlatformList(event);
                                                        }}
                                                        open={!!openSelectState[`platform-01`]}
                                                        onDropdownVisibleChange={(open) => toggleSelectOpen(`platform-01`, open)}
                                                        dropdownRender={menu => (
                                                            <>
                                                                <div className="custom_inside_searchbar_d2">
                                                                    <Input placeholder="Search" value={searchPlatformList} onChange={(e) => {
                                                                        handleSearchPlatformList(e)

                                                                    }}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Backspace') {
                                                                                if (searchPlatformList.length > 0) {

                                                                                    const input = getRef(`platform-01`).current?.input; // Get input element
                                                                                    const cursorPos = input.selectionStart;; // Get cursor position

                                                                                    if (cursorPos > 0) {
                                                                                        const newValue =
                                                                                            searchPlatformList.slice(0, cursorPos - 1) + // Keep text before cursor (excluding deleted char)
                                                                                            searchPlatformList.slice(cursorPos); // Keep text after cursor

                                                                                        setSearchPlatformList(newValue);
                                                                                        setTimeout(() => {
                                                                                            input.setSelectionRange(cursorPos - 1, cursorPos - 1);
                                                                                        }, 0);
                                                                                    }

                                                                                    e.stopPropagation();
                                                                                    e.preventDefault();


                                                                                } else {

                                                                                    e.stopPropagation();
                                                                                }
                                                                            }
                                                                        }}
                                                                        ref={getRef(`platform-01`)}
                                                                        prefix={<img src={searchIcon} alt="USP" />}
                                                                        allowClear
                                                                        onClear={() => {
                                                                            setSearchPlatformList('');
                                                                            setTimeout(() => { getRef(`platform-01`).current?.focus(); }, 0);
                                                                        }} />
                                                                </div>
                                                                {searchPlatformList.length === 0 && platformListOptions?.length > 0 &&
                                                                    <div
                                                                        className={`select_all_d2 ${(platformList?.length > 0 && platformList?.length !== platformListOptions?.length) ? 'intermediate_state' : ''}`}
                                                                        onClick={() => handleSelectAllPlatformList()}
                                                                    >

                                                                        <Checkbox
                                                                            checked={platformList?.length === platformListOptions?.length}
                                                                            onClick={(e) => e.stopPropagation()}
                                                                        >
                                                                            Select All
                                                                        </Checkbox>

                                                                    </div>
                                                                }
                                                                {menu}
                                                            </>
                                                        )}
                                                    >
                                                        {[
                                                            ...filterPlatformList?.filter(option => platformList?.includes(option.value)).sort((a, b) => a.label.localeCompare(b.label)), // Checked options first
                                                            ...filterPlatformList?.filter(option => !platformList?.includes(option.value)).sort((a, b) => a.label.localeCompare(b.label)) // Unchecked options next
                                                        ].map(option => (
                                                            <Option key={option.value} value={option.value}
                                                                className={option.disabled ? "disabled_checkbox_select_2" : ""}
                                                            >
                                                                <div
                                                                    onClick={() => handlePlatformList(option.value)}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    <Checkbox
                                                                        checked={platformList?.includes(option.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        disabled={option.disabled}
                                                                    >
                                                                        {option.label}
                                                                    </Checkbox>
                                                                </div>
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </div>

                                            </div>
                                        </Col>
                                    }
                                    {/* <Col>
                                        <div className="form_group form_select_multiple_group">
                                            <label className='form_label'>Country</label>
                                            <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100 form_content_block--group">
                                                <Select
                                                    value={countryList}
                                                    popupClassName='diff_select_d2 form_select_multiple--dropdown'
                                                    maxTagCount={1}
                                                    showSearch={false}
                                                    placeholder='- Select -'
                                                    className="form_select_multiple"
                                                    mode='multiple'
                                                    onChange={(event) => {
                                                        setCountryList(event);
                                                    }}
                                                    dropdownRender={menu => (
                                                        <>
                                                            <div className="custom_inside_searchbar_d2">
                                                                <Input placeholder="Search" value={searchCountryList} onChange={(e) => {
                                                                    handleSearchCountryList(e)

                                                                }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Backspace') {
                                                                            if (searchCountryList.length > 0) {

                                                                                const input = getRef(`country-01`).current?.input; // Get input element
                                                                                const cursorPos = input.selectionStart;; // Get cursor position

                                                                                if (cursorPos > 0) {
                                                                                    const newValue =
                                                                                        searchCountryList.slice(0, cursorPos - 1) + // Keep text before cursor (excluding deleted char)
                                                                                        searchCountryList.slice(cursorPos); // Keep text after cursor

                                                                                    setSearchCountryList(newValue);
                                                                                    setTimeout(() => {
                                                                                        input.setSelectionRange(cursorPos - 1, cursorPos - 1);
                                                                                    }, 0);
                                                                                }

                                                                                e.stopPropagation();
                                                                                e.preventDefault();


                                                                            } else {

                                                                                e.stopPropagation();
                                                                            }
                                                                        }
                                                                    }}

                                                                    ref={getRef(`country-01`)}
                                                                    prefix={<img src={searchIcon} alt="USP" />} allowClear />
                                                            </div>
                                                            {searchCountryList.length === 0 &&
                                                                <div
                                                                    className={`select_all_d2 ${(countryList?.length > 0 && countryList?.length !== countryListOptions?.length) ? 'intermediate_state' : ''}`}
                                                                    onClick={() => handleSelectAllCountryList()}
                                                                >

                                                                    <Checkbox
                                                                        checked={countryList?.length === countryListOptions?.length}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        Select All
                                                                    </Checkbox>

                                                                </div>
                                                            }
                                                            {menu}
                                                        </>
                                                    )}
                                                >
                                                    {[
                                                        ...filterCountryList?.filter(option => countryList?.includes(option.value)), // Checked options first
                                                        ...filterCountryList?.filter(option => !countryList?.includes(option.value)) // Unchecked options next
                                                    ].map(option => (
                                                        <Option key={option.value} value={option.value}
                                                            className={option.disabled ? "disabled_checkbox_select_2" : ""}
                                                        >
                                                            <div
                                                                onClick={() => handleCountryList(option.value)}
                                                                style={{ display: 'flex', alignItems: 'center' }}
                                                            >
                                                                <Checkbox
                                                                    checked={countryList?.includes(option.value)}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    disabled={option.disabled}
                                                                >
                                                                    {option.label}
                                                                </Checkbox>
                                                            </div>
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </div>
                                            {countryList.length > 0 &&
                                                <span className="clear_all"
                                                    onClick={() => {
                                                        setCountryList([]);
                                                    }}
                                                >
                                                    Clear all
                                                </span>
                                            }
                                        </div>
                                    </Col> */}
                                    {(props.role !== "admin" && props.role !== "u_admin") &&
                                        <Col>
                                            <div className="form_group form_select_multiple_group">
                                                <label className='form_label'>Publisher
                                                    {publisherList.length > 0 &&
                                                        <span className="clear_all"
                                                            onClick={() => {
                                                                setPublisherList([]);
                                                                // setPublisherListOptions((prevOptions) =>
                                                                //     prevOptions.map((option) => {
                                                                //         return { ...option, disabled: false };
                                                                //     })
                                                                // );

                                                                setZoneListOptions([]);
                                                                setZoneList([]);
                                                                setDomainListOptions([]);
                                                                setDomainList([]);
                                                                setMobileListOptions([]);
                                                                setMobileList([]);
                                                                setCtvListOptions([]);
                                                                setCtvList([]);

                                                            }}
                                                        >
                                                            Clear all
                                                        </span>
                                                    }
                                                </label>
                                                <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100 form_content_block--group">
                                                    <Select
                                                        value={publisherList}
                                                        popupClassName='diff_select_d2 form_select_multiple--dropdown'
                                                        maxTagCount={1}
                                                        showSearch={false}
                                                        placeholder='- Select -'
                                                        maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
                                                        className="form_select_multiple"
                                                        mode='multiple'
                                                        onChange={handlePublisherList}
                                                        open={!!openSelectState[`publisher-01`]}
                                                        onDropdownVisibleChange={(open) => toggleSelectOpen(`publisher-01`, open)}
                                                        dropdownRender={menu => (
                                                            <>
                                                                <div className="custom_inside_searchbar_d2">
                                                                    <Input placeholder="Search" value={searchPublisherList} onChange={(e) => {
                                                                        handleSearchPublisherList(e)

                                                                    }}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Backspace') {
                                                                                if (searchPublisherList.length > 0) {

                                                                                    const input = getRef(`publisher-01`).current?.input; // Get input element
                                                                                    const cursorPos = input.selectionStart;; // Get cursor position

                                                                                    if (cursorPos > 0) {
                                                                                        const newValue =
                                                                                            searchPublisherList.slice(0, cursorPos - 1) + // Keep text before cursor (excluding deleted char)
                                                                                            searchPublisherList.slice(cursorPos); // Keep text after cursor

                                                                                        setSearchPublisherList(newValue);
                                                                                        setTimeout(() => {
                                                                                            input.setSelectionRange(cursorPos - 1, cursorPos - 1);
                                                                                        }, 0);
                                                                                    }

                                                                                    e.stopPropagation();
                                                                                    e.preventDefault();


                                                                                } else {

                                                                                    e.stopPropagation();
                                                                                }
                                                                            }
                                                                        }}
                                                                        ref={getRef(`publisher-01`)}
                                                                        prefix={<img src={searchIcon} alt="USP" />}
                                                                        allowClear
                                                                        onClear={() => {
                                                                            setSearchPublisherList('');
                                                                            setTimeout(() => { getRef(`publisher-01`).current?.focus(); }, 0);
                                                                        }} />
                                                                </div>
                                                                {searchPublisherList.length === 0 && publisherListOptions.length > 0 &&
                                                                    <div
                                                                        className={`select_all_d2 ${(publisherList?.length > 0 && publisherList?.length !== publisherListOptions?.length) ? 'intermediate_state' : ''}`}
                                                                        onClick={() => handleSelectAllPublisherList()}
                                                                    >

                                                                        <Checkbox
                                                                            checked={publisherList?.length === publisherListOptions?.length}
                                                                            onClick={(e) => e.stopPropagation()}
                                                                        >
                                                                            Select All
                                                                        </Checkbox>

                                                                    </div>
                                                                }
                                                                {menu}
                                                            </>
                                                        )}
                                                    >
                                                        {[
                                                            ...filterPublisherList?.filter(option => publisherList?.includes(option.value)), // Checked options first
                                                            ...filterPublisherList?.filter(option => !publisherList?.includes(option.value)) // Unchecked options next
                                                        ].map(option => (
                                                            <Option key={option.value} value={option.value}
                                                                className={option.disabled ? "disabled_checkbox_select_2" : ""}
                                                            >
                                                                <div
                                                                    // onClick={() => handlePublisherList(option.value)}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    <Checkbox
                                                                        checked={publisherList?.includes(option.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        disabled={option.disabled}
                                                                    >
                                                                        {option.label}
                                                                    </Checkbox>
                                                                </div>
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </div>

                                            </div>
                                        </Col>
                                    }
                                    <Col>
                                        <div className="form_group form_select_multiple_group">
                                            <label className='form_label'>Zone
                                                {zoneList.length > 0 &&
                                                    <span className="clear_all"
                                                        onClick={() => {
                                                            setZoneList([]);
                                                        }}
                                                    >
                                                        Clear all
                                                    </span>
                                                }
                                            </label>
                                            <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100 form_content_block--group">
                                                <Select
                                                    value={zoneList}
                                                    popupClassName='diff_select_d2 --padding_remove_cls form_select_multiple--dropdown'
                                                    maxTagCount={1}
                                                    showSearch={false}
                                                    placeholder='- Select -'
                                                    maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
                                                    className="form_select_multiple"
                                                    mode='multiple'
                                                    onChange={(event) => {
                                                        setZoneList(event);
                                                    }}
                                                    open={!!openSelectState[`zone-01`]}
                                                    onDropdownVisibleChange={(open) => toggleSelectOpen(`zone-01`, open)}
                                                    dropdownRender={menu => (
                                                        <>
                                                            <div className="custom_inside_searchbar_d2">
                                                                <Input placeholder="Search" value={searchZoneList} onChange={(e) => {
                                                                    handleSearchZoneList(e)

                                                                }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Backspace') {
                                                                            if (searchZoneList.length > 0) {

                                                                                const input = getRef(`zone-01`).current?.input; // Get input element
                                                                                const cursorPos = input.selectionStart;; // Get cursor position

                                                                                if (cursorPos > 0) {
                                                                                    const newValue =
                                                                                        searchZoneList.slice(0, cursorPos - 1) + // Keep text before cursor (excluding deleted char)
                                                                                        searchZoneList.slice(cursorPos); // Keep text after cursor

                                                                                    setSearchZoneList(newValue);
                                                                                    setTimeout(() => {
                                                                                        input.setSelectionRange(cursorPos - 1, cursorPos - 1);
                                                                                    }, 0);
                                                                                }

                                                                                e.stopPropagation();
                                                                                e.preventDefault();


                                                                            } else {

                                                                                e.stopPropagation();
                                                                            }
                                                                        }
                                                                    }}
                                                                    ref={getRef(`zone-01`)}
                                                                    prefix={<img src={searchIcon} alt="USP" />}
                                                                    allowClear
                                                                    onClear={() => {
                                                                        setSearchZoneList('');
                                                                        setTimeout(() => { getRef(`zone-01`).current?.focus(); }, 0);
                                                                    }} />
                                                            </div>
                                                            {searchZoneList.length === 0 && zoneListOptions?.length > 0 &&
                                                                <div
                                                                    className={`select_all_d2 ${(zoneList?.length > 0 && zoneList?.length !== zoneListOptions?.length) ? 'intermediate_state' : ''}`}
                                                                    onClick={() => handleSelectAllZoneList()}
                                                                >

                                                                    <Checkbox
                                                                        checked={zoneList?.length === zoneListOptions?.length}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        Select All
                                                                    </Checkbox>

                                                                </div>
                                                            }
                                                            {menu}
                                                        </>
                                                    )}
                                                >
                                                    {[
                                                        ...filterZoneList?.filter(option => zoneList?.includes(option.value)), // Checked options first
                                                        ...filterZoneList?.filter(option => !zoneList?.includes(option.value)) // Unchecked options next
                                                    ].map(option => (
                                                        <Option key={option.value} value={option.value}
                                                            className={option.disabled ? "disabled_checkbox_select_2" : ""}
                                                        >
                                                            <div
                                                                onClick={() => handleZoneList(option.value)}
                                                                style={{ display: 'flex', alignItems: 'center' }}
                                                            >
                                                                <Checkbox
                                                                    checked={zoneList?.includes(option.value)}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    disabled={option.disabled}
                                                                >
                                                                    <Tooltip title={option.label}>
                                                                        {option.label.length > 38 ? <>{option.label.slice(0, 38)}...</> : <>{option.label}</>}
                                                                    </Tooltip>
                                                                </Checkbox>
                                                            </div>
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </div>

                                        </div>
                                    </Col>
                                    {/* <Col>
                                        <div className="form_group form_select_multiple_group">
                                            <label className='form_label'>Domain</label>
                                            <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100 form_content_block--group">
                                                <Select
                                                    value={domainList}
                                                    popupClassName='diff_select_d2 form_select_multiple--dropdown'
                                                    maxTagCount={1}
                                                    showSearch={false}
                                                    placeholder='- Select -'
                                                    className="form_select_multiple"
                                                    mode='multiple'
                                                    onChange={(event) => {
                                                        setDomainList(event);
                                                    }}
                                                     open={!!openSelectState[`domain-01`]}
                                                     onDropdownVisibleChange={(open) => toggleSelectOpen(`domain-01`, open)}
                                                    dropdownRender={menu => (
                                                        <>
                                                            <div className="custom_inside_searchbar_d2">
                                                                <Input placeholder="Search" value={searchDomainList} onChange={(e) => {
                                                                    handleSearchDomainList(e)

                                                                }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Backspace') {
                                                                            if (searchDomainList.length > 0) {

                                                                                const input = getRef(`domain-01`).current?.input; // Get input element
                                                                                const cursorPos = input.selectionStart;; // Get cursor position

                                                                                if (cursorPos > 0) {
                                                                                    const newValue =
                                                                                        searchDomainList.slice(0, cursorPos - 1) + // Keep text before cursor (excluding deleted char)
                                                                                        searchDomainList.slice(cursorPos); // Keep text after cursor

                                                                                    setSearchDomainList(newValue);
                                                                                    setTimeout(() => {
                                                                                        input.setSelectionRange(cursorPos - 1, cursorPos - 1);
                                                                                    }, 0);
                                                                                }

                                                                                e.stopPropagation();
                                                                                e.preventDefault();


                                                                            } else {

                                                                                e.stopPropagation();
                                                                            }
                                                                        }
                                                                    }}
                                                                    ref={getRef(`domain-01`)}
                                                                    prefix={<img src={searchIcon} alt="USP" />}
                                                                    allowClear
                                                                    onClear={() => {
                                                                        setSearchDomainList('');
                                                                        setTimeout(() => { getRef(`domain-01`).current?.focus(); }, 0);
                                                                    }} />
                                                            </div>
                                                            {searchDomainList.length === 0 && domainListOptions.length > 0 &&
                                                                <div
                                                                    className={`select_all_d2 ${(domainList?.length > 0 && domainList?.length !== domainListOptions?.length) ? 'intermediate_state' : ''}`}
                                                                    onClick={() => handleSelectAllDomainList()}
                                                                >

                                                                    <Checkbox
                                                                        checked={domainList?.length === domainListOptions?.length}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        Select All
                                                                    </Checkbox>

                                                                </div>
                                                            }
                                                            {menu}
                                                        </>
                                                    )}
                                                >
                                                    {[
                                                        ...filterDomainList?.filter(option => domainList?.includes(option.value)), // Checked options first
                                                        ...filterDomainList?.filter(option => !domainList?.includes(option.value)) // Unchecked options next
                                                    ].map(option => (
                                                        <Option key={option.value} value={option.value}
                                                            className={option.disabled ? "disabled_checkbox_select_2" : ""}
                                                        >
                                                            <div
                                                                onClick={() => handleDomainList(option.value)}
                                                                style={{ display: 'flex', alignItems: 'center' }}
                                                            >
                                                                <Checkbox
                                                                    checked={domainList?.includes(option.value)}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    disabled={option.disabled}
                                                                >
                                                                    {option.label}
                                                                </Checkbox>
                                                            </div>
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </div>
                                            {domainList.length > 0 &&
                                                <span className="clear_all"
                                                    onClick={() => {
                                                        setDomainList([]);
                                                    }}
                                                >
                                                    Clear all
                                                </span>
                                            }
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className="form_group form_select_multiple_group">
                                            <label className='form_label'>Mobile</label>
                                            <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100 form_content_block--group">
                                                <Select
                                                    value={mobileList}
                                                    popupClassName='diff_select_d2 form_select_multiple--dropdown'
                                                    maxTagCount={1}
                                                    showSearch={false}
                                                    placeholder='- Select -'
                                                    className="form_select_multiple"
                                                    mode='multiple'
                                                    onChange={(event) => {
                                                        setMobileList(event);
                                                    }}
                                                     open={!!openSelectState[`mobile-01`]}
                                                     onDropdownVisibleChange={(open) => toggleSelectOpen(`mobile-01`, open)}
                                                    dropdownRender={menu => (
                                                        <>
                                                            <div className="custom_inside_searchbar_d2">
                                                                <Input placeholder="Search" value={searchMobileList} onChange={(e) => {
                                                                    handleSearchMobileList(e)

                                                                }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Backspace') {
                                                                            if (searchMobileList.length > 0) {

                                                                                const input = getRef(`mobile-01`).current?.input; // Get input element
                                                                                const cursorPos = input.selectionStart;; // Get cursor position

                                                                                if (cursorPos > 0) {
                                                                                    const newValue =
                                                                                        searchMobileList.slice(0, cursorPos - 1) + // Keep text before cursor (excluding deleted char)
                                                                                        searchMobileList.slice(cursorPos); // Keep text after cursor

                                                                                    setSearchMobileList(newValue);
                                                                                    setTimeout(() => {
                                                                                        input.setSelectionRange(cursorPos - 1, cursorPos - 1);
                                                                                    }, 0);
                                                                                }

                                                                                e.stopPropagation();
                                                                                e.preventDefault();


                                                                            } else {

                                                                                e.stopPropagation();
                                                                            }
                                                                        }
                                                                    }}
                                                                    ref={getRef(`mobile-01`)}
                                                                    prefix={<img src={searchIcon} alt="USP" />}
                                                                    allowClear
                                                                    onClear={() => {
                                                                        setSearchMobileList('');
                                                                        setTimeout(() => { getRef(`mobile-01`).current?.focus(); }, 0);
                                                                    }} />
                                                            </div>
                                                            {searchMobileList.length === 0 && mobileListOptions?.length > 0 &&
                                                                <div
                                                                    className={`select_all_d2 ${(mobileList?.length > 0 && mobileList?.length !== mobileListOptions?.length) ? 'intermediate_state' : ''}`}
                                                                    onClick={() => handleSelectAllMobileList()}
                                                                >

                                                                    <Checkbox
                                                                        checked={mobileList?.length === mobileListOptions?.length}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        Select All
                                                                    </Checkbox>

                                                                </div>
                                                            }
                                                            {menu}
                                                        </>
                                                    )}
                                                >
                                                    {[
                                                        ...filterMobileList?.filter(option => mobileList?.includes(option.value)), // Checked options first
                                                        ...filterMobileList?.filter(option => !mobileList?.includes(option.value)) // Unchecked options next
                                                    ].map(option => (
                                                        <Option key={option.value} value={option.value}
                                                            className={option.disabled ? "disabled_checkbox_select_2" : ""}
                                                        >
                                                            <div
                                                                onClick={() => handleMobileList(option.value)}
                                                                style={{ display: 'flex', alignItems: 'center' }}
                                                            >
                                                                <Checkbox
                                                                    checked={mobileList?.includes(option.value)}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    disabled={option.disabled}
                                                                >
                                                                    {option.label}
                                                                </Checkbox>
                                                            </div>
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </div>
                                            {mobileList.length > 0 &&
                                                <span className="clear_all"
                                                    onClick={() => {
                                                        setMobileList([]);
                                                    }}
                                                >
                                                    Clear all
                                                </span>
                                            }
                                        </div>
                                    </Col>

                                    <Col>
                                        <div className="form_group form_select_multiple_group">
                                            <label className='form_label'>CTV</label>
                                            <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100 form_content_block--group">
                                                <Select
                                                    value={ctvList}
                                                    popupClassName='diff_select_d2 form_select_multiple--dropdown'
                                                    maxTagCount={1}
                                                    showSearch={false}
                                                    placeholder='- Select -'
                                                    className="form_select_multiple"
                                                    mode='multiple'
                                                    onChange={(event) => {
                                                        setCtvList(event);
                                                    }}
                                                     open={!!openSelectState[`ctv-01`]}
                                                     onDropdownVisibleChange={(open) => toggleSelectOpen(`ctv-01`, open)}
                                                    dropdownRender={menu => (
                                                        <>
                                                            <div className="custom_inside_searchbar_d2">
                                                                <Input placeholder="Search" value={searchCtvList} onChange={(e) => {
                                                                    handleSearchCtvList(e)

                                                                }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Backspace') {
                                                                            if (searchCtvList.length > 0) {

                                                                                const input = getRef(`ctv-01`).current?.input; // Get input element
                                                                                const cursorPos = input.selectionStart;; // Get cursor position

                                                                                if (cursorPos > 0) {
                                                                                    const newValue =
                                                                                        searchCtvList.slice(0, cursorPos - 1) + // Keep text before cursor (excluding deleted char)
                                                                                        searchCtvList.slice(cursorPos); // Keep text after cursor

                                                                                    setSearchCtvList(newValue);
                                                                                    setTimeout(() => {
                                                                                        input.setSelectionRange(cursorPos - 1, cursorPos - 1);
                                                                                    }, 0);
                                                                                }

                                                                                e.stopPropagation();
                                                                                e.preventDefault();


                                                                            } else {

                                                                                e.stopPropagation();
                                                                            }
                                                                        }
                                                                    }}
                                                                    ref={getRef(`ctv-01`)}
                                                                    prefix={<img src={searchIcon} alt="USP" />}
                                                                    allowClear
                                                                    onClear={() => {
                                                                        setSearchCtvList('');
                                                                        setTimeout(() => { getRef(`ctv-01`).current?.focus(); }, 0);
                                                                    }} />
                                                            </div>
                                                            {searchCtvList.length === 0 && ctvListOptions?.length > 0 &&
                                                                <div
                                                                    className={`select_all_d2 ${(ctvList?.length > 0 && ctvList?.length !== ctvListOptions?.length) ? 'intermediate_state' : ''}`}
                                                                    onClick={() => handleSelectAllCtvList()}
                                                                >

                                                                    <Checkbox
                                                                        checked={ctvList?.length === ctvListOptions?.length}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        Select All
                                                                    </Checkbox>

                                                                </div>
                                                            }
                                                            {menu}
                                                        </>
                                                    )}
                                                >
                                                    {[
                                                        ...filterCtvList?.filter(option => ctvList?.includes(option.value)), // Checked options first
                                                        ...filterCtvList?.filter(option => !ctvList?.includes(option.value)) // Unchecked options next
                                                    ].map(option => (
                                                        <Option key={option.value} value={option.value}
                                                            className={option.disabled ? "disabled_checkbox_select_2" : ""}
                                                        >
                                                            <div
                                                                onClick={() => handleCtvList(option.value)}
                                                                style={{ display: 'flex', alignItems: 'center' }}
                                                            >
                                                                <Checkbox
                                                                    checked={ctvList?.includes(option.value)}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    disabled={option.disabled}
                                                                >
                                                                    {option.label}
                                                                </Checkbox>
                                                            </div>
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </div>
                                            {ctvList.length > 0 &&
                                                <span className="clear_all"
                                                    onClick={() => {
                                                        setCtvList([]);
                                                    }}
                                                >
                                                    Clear all
                                                </span>
                                            }
                                        </div>
                                    </Col>

                                    <Col>
                                        <div className="form_group form_select_multiple_group">
                                            <label className='form_label'>Traffic Type</label>
                                            <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100 form_content_block--group">
                                                <Select
                                                    value={trafficTypeList}
                                                    popupClassName='diff_select_d2 form_select_multiple--dropdown'
                                                    maxTagCount={1}
                                                    showSearch={false}
                                                    placeholder='- Select -'
                                                    className="form_select_multiple"
                                                    mode='multiple'
                                                    onChange={(event) => {
                                                        setTrafficTypeList(event);
                                                    }}
                                                     open={!!openSelectState[`traffictype-01`]}
                                                     onDropdownVisibleChange={(open) => toggleSelectOpen(`traffictype-01`, open)}
                                                    dropdownRender={menu => (
                                                        <>
                                                            <div className="custom_inside_searchbar_d2">
                                                                <Input placeholder="Search" value={searchTrafficTypeList} onChange={(e) => {
                                                                    handleSearchTrafficTypeList(e)

                                                                }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Backspace') {
                                                                            if (searchTrafficTypeList.length > 0) {

                                                                                const input = getRef(`traffictype-01`).current?.input; // Get input element
                                                                                const cursorPos = input.selectionStart;; // Get cursor position

                                                                                if (cursorPos > 0) {
                                                                                    const newValue =
                                                                                        searchTrafficTypeList.slice(0, cursorPos - 1) + // Keep text before cursor (excluding deleted char)
                                                                                        searchTrafficTypeList.slice(cursorPos); // Keep text after cursor

                                                                                    setSearchTrafficTypeList(newValue);
                                                                                    setTimeout(() => {
                                                                                        input.setSelectionRange(cursorPos - 1, cursorPos - 1);
                                                                                    }, 0);
                                                                                }

                                                                                e.stopPropagation();
                                                                                e.preventDefault();


                                                                            } else {

                                                                                e.stopPropagation();
                                                                            }
                                                                        }
                                                                    }}
                                                                    ref={getRef(`traffictype-01`)}
                                                                    prefix={<img src={searchIcon} alt="USP" />}
                                                                    allowClear
                                                                    onClear={() => {
                                                                        setSearchTrafficTypeList('');
                                                                        setTimeout(() => { getRef(`traffictype-01`).current?.focus(); }, 0);
                                                                    }} />
                                                            </div>
                                                            {searchTrafficTypeList.length === 0 && trafficTypeListOptions?.length > 0 &&
                                                                <div
                                                                    className={`select_all_d2 ${(trafficTypeList?.length > 0 && trafficTypeList?.length !== trafficTypeListOptions?.length) ? 'intermediate_state' : ''}`}
                                                                    onClick={() => handleSelectAllTrafficTypeList()}
                                                                >

                                                                    <Checkbox
                                                                        checked={trafficTypeList?.length === trafficTypeListOptions?.length}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        Select All
                                                                    </Checkbox>

                                                                </div>
                                                            }
                                                            {menu}
                                                        </>
                                                    )}
                                                >
                                                    {[
                                                        ...filterTrafficTypeList?.filter(option => trafficTypeList?.includes(option.value)), // Checked options first
                                                        ...filterTrafficTypeList?.filter(option => !trafficTypeList?.includes(option.value)) // Unchecked options next
                                                    ].map(option => (
                                                        <Option key={option.value} value={option.value}
                                                            className={option.disabled ? "disabled_checkbox_select_2" : ""}
                                                        >
                                                            <div
                                                                onClick={() => handleTrafficTypeList(option.value)}
                                                                style={{ display: 'flex', alignItems: 'center' }}
                                                            >
                                                                <Checkbox
                                                                    checked={trafficTypeList?.includes(option.value)}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    disabled={option.disabled}
                                                                >
                                                                    {option.label}
                                                                </Checkbox>
                                                            </div>
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </div>
                                            {trafficTypeList.length > 0 &&
                                                <span className="clear_all"
                                                    onClick={() => {
                                                        setTrafficTypeList([]);
                                                    }}
                                                >
                                                    Clear all
                                                </span>
                                            }
                                        </div>
                                    </Col>

                                    <Col>
                                        <div className="form_group form_select_multiple_group">
                                            <label className='form_label'>Device Type</label>
                                            <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100 form_content_block--group">
                                                <Select
                                                    value={deviceTypeList}
                                                    popupClassName='diff_select_d2 form_select_multiple--dropdown'
                                                    maxTagCount={1}
                                                    showSearch={false}
                                                    placeholder='- Select -'
                                                    className="form_select_multiple"
                                                    mode='multiple'
                                                    onChange={(event) => {
                                                        setDeviceTypeList(event);
                                                    }}
                                                     open={!!openSelectState[`devicetype-01`]}
                                                     onDropdownVisibleChange={(open) => toggleSelectOpen(`devicetype-01`, open)}
                                                    dropdownRender={menu => (
                                                        <>
                                                            <div className="custom_inside_searchbar_d2">
                                                                <Input placeholder="Search" value={searchDeviceTypeList} onChange={(e) => {
                                                                    handleSearchDeviceTypeList(e)

                                                                }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Backspace') {
                                                                            if (searchDeviceTypeList.length > 0) {

                                                                                const input = getRef(`devicetype-01`).current?.input; // Get input element
                                                                                const cursorPos = input.selectionStart;; // Get cursor position

                                                                                if (cursorPos > 0) {
                                                                                    const newValue =
                                                                                        searchDeviceTypeList.slice(0, cursorPos - 1) + // Keep text before cursor (excluding deleted char)
                                                                                        searchDeviceTypeList.slice(cursorPos); // Keep text after cursor

                                                                                    setSearchDeviceTypeList(newValue);
                                                                                    setTimeout(() => {
                                                                                        input.setSelectionRange(cursorPos - 1, cursorPos - 1);
                                                                                    }, 0);
                                                                                }

                                                                                e.stopPropagation();
                                                                                e.preventDefault();


                                                                            } else {

                                                                                e.stopPropagation();
                                                                            }
                                                                        }
                                                                    }}
                                                                    ref={getRef(`devicetype-01`)}
                                                                    prefix={<img src={searchIcon} alt="USP" />}
                                                                    allowClear
                                                                    onClear={() => {
                                                                        setSearchDeviceTypeList('');
                                                                        setTimeout(() => { getRef(`devicetype-01`).current?.focus(); }, 0);
                                                                    }} />
                                                            </div>
                                                            {searchDeviceTypeList.length === 0 && deviceTypeListOptions?.length > 0 &&
                                                                <div
                                                                    className={`select_all_d2 ${(deviceTypeList?.length > 0 && deviceTypeList?.length !== deviceTypeListOptions?.length) ? 'intermediate_state' : ''}`}
                                                                    onClick={() => handleSelectAllDeviceTypeList()}
                                                                >

                                                                    <Checkbox
                                                                        checked={deviceTypeList?.length === deviceTypeListOptions?.length}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        Select All
                                                                    </Checkbox>

                                                                </div>
                                                            }
                                                            {menu}
                                                        </>
                                                    )}
                                                >
                                                    {[
                                                        ...filterDeviceTypeList?.filter(option => deviceTypeList?.includes(option.value)), // Checked options first
                                                        ...filterDeviceTypeList?.filter(option => !deviceTypeList?.includes(option.value)) // Unchecked options next
                                                    ].map(option => (
                                                        <Option key={option.value} value={option.value}
                                                            className={option.disabled ? "disabled_checkbox_select_2" : ""}
                                                        >
                                                            <div
                                                                onClick={() => handleDeviceTypeList(option.value)}
                                                                style={{ display: 'flex', alignItems: 'center' }}
                                                            >
                                                                <Checkbox
                                                                    checked={deviceTypeList?.includes(option.value)}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    disabled={option.disabled}
                                                                >
                                                                    {option.label}
                                                                </Checkbox>
                                                            </div>
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </div>
                                            {deviceTypeList.length > 0 &&
                                                <span className="clear_all"
                                                    onClick={() => {
                                                        setDeviceTypeList([]);
                                                    }}
                                                >
                                                    Clear all
                                                </span>
                                            }
                                        </div>
                                    </Col> */}
                                    <Col>
                                        <div className="form_group form_select_multiple_group">
                                            <label className='form_label'>Group By
                                                {
                                                    dimensionsList.some(
                                                        (item) => item !== "publisher"
                                                    ) &&
                                                    <span className="clear_all"
                                                        onClick={() => {
                                                            setDimensionsList(["publisher"]);
                                                            setDimensionsListOptions((prevOptions) =>
                                                                prevOptions.map((option) => {
                                                                    if (option.value === "publisher") {
                                                                        return { ...option, disabled: true }; // keep publisher disabled
                                                                    }
                                                                    return { ...option, disabled: false };
                                                                })
                                                            );
                                                        }}
                                                    >
                                                        Clear all
                                                    </span>
                                                }
                                            </label>
                                            <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100 form_content_block--group">
                                                <Select
                                                    value={dimensionsList}
                                                    popupClassName='diff_select_d2 form_select_multiple--dropdown'
                                                    maxTagCount={1}
                                                    showSearch={false}
                                                    maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
                                                    placeholder='- Select -'
                                                    className="form_select_multiple"
                                                    mode='multiple'
                                                    onChange={handleDimensionsList}
                                                    open={!!openSelectState[`dimensions-01`]}
                                                    onDropdownVisibleChange={(open) => toggleSelectOpen(`dimensions-01`, open)}
                                                    dropdownRender={menu => (
                                                        <>
                                                            <div className="custom_inside_searchbar_d2">
                                                                <Input placeholder="Search" value={searchDimensionsList} onChange={(e) => {
                                                                    handleSearchDimensionsList(e)

                                                                }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Backspace') {
                                                                            if (searchDimensionsList.length > 0) {

                                                                                const input = getRef(`dimensions-01`).current?.input; // Get input element
                                                                                const cursorPos = input.selectionStart;; // Get cursor position

                                                                                if (cursorPos > 0) {
                                                                                    const newValue =
                                                                                        searchDimensionsList.slice(0, cursorPos - 1) + // Keep text before cursor (excluding deleted char)
                                                                                        searchDimensionsList.slice(cursorPos); // Keep text after cursor

                                                                                    setSearchDimensionsList(newValue);
                                                                                    setTimeout(() => {
                                                                                        input.setSelectionRange(cursorPos - 1, cursorPos - 1);
                                                                                    }, 0);
                                                                                }

                                                                                e.stopPropagation();
                                                                                e.preventDefault();


                                                                            } else {

                                                                                e.stopPropagation();
                                                                            }
                                                                        }
                                                                    }}
                                                                    ref={getRef(`dimensions-01`)}
                                                                    prefix={<img src={searchIcon} alt="USP" />}
                                                                    allowClear
                                                                    onClear={() => {
                                                                        setSearchDimensionsList('');
                                                                        setTimeout(() => { getRef(`dimensions-01`).current?.focus(); }, 0);
                                                                    }} />
                                                            </div>
                                                            {/* {searchDimensionsList.length === 0 &&
                                                                <div
                                                                    className={`select_all_d2 ${(dimensionsList?.length > 0 && dimensionsList?.length !== dimensionsListOptions?.length) ? 'intermediate_state' : ''}`}
                                                                    onClick={() => handleSelectAllDimensionsList()}
                                                                >

                                                                    <Checkbox
                                                                        checked={dimensionsList?.length === dimensionsListOptions?.length}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        Select All
                                                                    </Checkbox>

                                                                </div>
                                                            } */}
                                                            {menu}
                                                        </>
                                                    )}
                                                >
                                                    {[
                                                        ...filterDimensionsList?.filter(option => dimensionsList?.includes(option.value)).sort((a, b) => a.label.localeCompare(b.label)), // Checked options first
                                                        ...filterDimensionsList?.filter(option => !dimensionsList?.includes(option.value)).sort((a, b) => a.label.localeCompare(b.label)) // Unchecked options next
                                                    ].map(option => (
                                                        <Option key={option.value} value={option.value}
                                                            className={option.disabled ? "disabled_checkbox_select_2" : ""}
                                                        >
                                                            <div
                                                                // onClick={() => handleDimensionsList(option.value)}
                                                                style={{ display: 'flex', alignItems: 'center' }}
                                                            >
                                                                <Checkbox
                                                                    checked={dimensionsList?.includes(option.value)}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    disabled={option.disabled}
                                                                >
                                                                    {option.label}
                                                                </Checkbox>
                                                            </div>
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </div>

                                        </div>
                                    </Col>

                                    {/* <Col>
                                        <div className="form_group">
                                            <label className='form_label'>Media Type</label>
                                            <Select value={value} allowClear placeholder="Select" className="ant_form_select"
                                                showSearch={false} onChange={(val) => setValue(val)}
                                                open={true}
                                                dropdownRender={menu => (
                                                    <>
                                                        <div className="form_select_multiple--dropdown">
                                                            <Input placeholder="Search"
                                                                prefix={<img src={searchIcon} alt="USP" />}
                                                                value={searchValue}
                                                                onChange={(e) =>
                                                                    setSearchValue(e.target.value)
                                                                }
                                                                allowClear
                                                            />
                                                        </div>
                                                        {menu}
                                                    </>
                                                )}
                                            >
                                                {filteredOptions.map(option => (
                                                    <Option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </div>
                                    </Col> */}



                                </Row>
                            </Col>
                        </Row>
                        <div className='filter_content_block--footer justify-content-between align-items-center'>
                            <div className="d-flex align-items-center justify-content-between" style={{ gap: '0.8rem' }}>
                                <button className='btn_brand btn'
                                    onClick={() => {

                                        if ((props.role !== "admin" && props.role !== "u_admin")) {
                                            if (platformList?.length === 0) {
                                                notifyfailure("Please select atleast one platform")
                                                return
                                            }
                                        }

                                        // if ((dimensionsList.includes("site_domain") || dimensionsList.includes("app_bundle")) && platform === "adkernel") {
                                        setPaginationProcess("backend")
                                        setLoading(false)
                                        setInitialLoad(true)
                                        setData([])
                                        setTotalData([])
                                        setExportData([])
                                        setTotal([])
                                        setSortObject({
                                            name: "pub_gross_impressions",
                                            type: -1
                                        })

                                        let tempPage = { ...page }
                                        tempPage.current = 1
                                        tempPage.total = 0
                                        setPage(tempPage)

                                        setDateRangePreviousApplied(dateRange)
                                        setPlatformListPreviousApplied(platformList)
                                        setCountryListPreviousApplied(countryList)
                                        setPublisherListPreviousApplied(publisherList)
                                        setZoneListPreviousApplied(zoneList)
                                        setDomainListPreviousApplied(domainList)
                                        setMobileListPreviousApplied(mobileList)
                                        setCtvListPreviousApplied(ctvList)
                                        setTrafficTypeListPreviousApplied(trafficTypeList)
                                        setDeviceTypeListPreviousApplied(deviceTypeList)
                                        setDimensionsListPreviousApplied(dimensionsList)

                                        isGenerateCallRef.current = true;
                                        setColvis({});
                                        setColvisOptions([]);

                                        // (dateRangePreviousApplied, platformListPreviousApplied, countryListPreviousApplied, publisherListPreviousApplied, zoneListPreviousApplied, domainListPreviousApplied, mobileListPreviousApplied, ctvListPreviousApplied, trafficTypeListPreviousApplied, deviceTypeListPreviousApplied, dimensionsListPreviousApplied, paginationReload, sortRelated, isExport)

                                        getDataViaBackend(dateRange, platformList, countryList, publisherList, zoneList, domainList, mobileList, ctvList, trafficTypeList, deviceTypeList, dimensionsList, search, 1, {
                                            name: "pub_gross_impressions",
                                            type: -1
                                        }, "")
                                    }
                                        // else {
                                        //     setPaginationProcess("frontend")
                                        //     getDataViaFrontend()
                                        // }

                                    }
                                // }}
                                >Generate Report</button>
                                <button className='btn_text btn'
                                    onClick={resetFilter}
                                >Reset</button>
                            </div>
                            <p className="notice_text">Data shown in PST timezone</p>
                        </div>
                    </div>

                    {!loading &&
                        <div className="tab-content">

                            <div>
                                <div className="table_list_block  --reprot_list">
                                    <Row>
                                        <Col span={18}>
                                            <div className='metrics_card_block --metrics_card_block_repo'>

                                                {tileRequests !== undefined && tileRequests !== null &&

                                                    <div className="metrics_card --4">
                                                        <div className="--content">
                                                            <div className="--details">
                                                                <h2 className="heading">{formatNumber(tileRequests)}</h2>
                                                                <p className="text">Requests</p>
                                                            </div>
                                                            <div className="--icon">
                                                                <img src={requestsIcon} alt='Helix' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                {/* 
                                                <div className="metrics_card --2">
                                                    <div className="--content">
                                                        <div className="--details">
                                                            <h2 className="heading">{formatNumber(tileBids)}</h2>
                                                            <p className="text">Bids</p>
                                                        </div>
                                                        <div className="--icon">
                                                            <img src={bidsIcon} alt='Helix' />
                                                        </div>
                                                    </div>
                                                </div> */}


                                                {tileImpressions !== undefined && tileImpressions !== null &&
                                                    <div className="metrics_card --5">
                                                        <div className="--content">
                                                            <div className="--details">
                                                                <h2 className="heading">{formatNumber(tileImpressions)}</h2>
                                                                <p className="text">Impressions</p>
                                                            </div>
                                                            <div className="--icon">
                                                                <img src={impressionsIcon} alt='Helix' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                }


                                                {tileClicks !== undefined && tileClicks !== null &&
                                                    <div className="metrics_card --1">
                                                        <div className="--content">
                                                            <div className="--details">
                                                                <h2 className="heading">{formatNumber(tileClicks)}</h2>
                                                                <p className="text">Clicks</p>
                                                            </div>
                                                            <div className="--icon">
                                                                <img src={clicksIcon} alt='Helix' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                }

                                            </div>
                                        </Col>
                                    </Row>

                                    <>
                                        <div className="table_content--box no_data_screen_view_different_table_repo">
                                            {!initialLoad &&
                                                <div className="table_content--header">
                                                    <Input
                                                        placeholder="Search"
                                                        allowClear
                                                        className="form_control_input --search"
                                                        value={search}
                                                        disabled={backendLoading}
                                                        onChange={(e) => {
                                                            setSearch(e.target.value)
                                                        }}
                                                    />


                                                    <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                                        {(props.role !== "admin" && props.role !== "u_admin") && <>
                                                            {colvisOptions.length > 0 && (
                                                                <AntDropdown
                                                                    trigger={['click']}
                                                                    open={isColumnsDropdownOpen}
                                                                    onOpenChange={setIsColumnsDropdownOpen}
                                                                    dropdownRender={() => (
                                                                        <div className={`columns-dropdown ${isColumnsDropdownOpen ? 'report_column_popup_div' : ''}`}>
                                                                            <div>
                                                                                <Checkbox
                                                                                    indeterminate={isColvisIndeterminate}
                                                                                    checked={isColvisAllChecked}
                                                                                    onChange={(e) => {
                                                                                        const updated = {};
                                                                                        colvisOptions.forEach(opt => { updated[opt.value] = e.target.checked; });
                                                                                        setColvis(updated);
                                                                                    }}
                                                                                >
                                                                                    <span>Select all</span>
                                                                                </Checkbox>
                                                                            </div>
                                                                            <hr className="horizontal_line_hr_cls" />
                                                                            <div className="report_columns_dropdown_options">
                                                                                {colvisOptions.map(({ label, value }) => {
                                                                                    const isChecked = colvis[value] !== false;
                                                                                    return (
                                                                                        <Checkbox
                                                                                            key={value}
                                                                                            checked={isChecked}
                                                                                            onChange={() => setColvis(prev => ({ ...prev, [value]: !prev[value] }))}
                                                                                        >
                                                                                            {label?.length >= 25 ? <Tooltip title={label}>{label.slice(0, 25)}...</Tooltip> : label}
                                                                                        </Checkbox>
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                >
                                                                    <div className="custom_filter_design_d2 --report_new_layout_design_btn">
                                                                        <Button className="export_btn_d2" icon={
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                <path d="M1.5 3H5.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M8.5 3H12.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M1.5 7H5.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M8.5 7H12.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M1.5 11H5.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M8.5 11H12.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                            </svg>
                                                                        }>
                                                                            Columns
                                                                        </Button>
                                                                    </div>
                                                                </AntDropdown>
                                                            )}
                                                        </>
                                                        }

                                                        {exportData.length === 0 || backendLoading ?
                                                            <Button
                                                                className="export_btn_d2"
                                                                disabled={true}
                                                                style={{ pointerEvents: "none" }}
                                                            >
                                                                <img src={mediaKitIcon} alt='' />
                                                                Export
                                                            </Button>
                                                            :
                                                            paginationProcess === "backend" && exportBackendLoading ?
                                                                <button className="btn btn_export --loader">
                                                                    <div className="--icon">
                                                                        <img
                                                                            src={downloadIcon}
                                                                            alt="USP"
                                                                            className="download_icon"
                                                                        />
                                                                        <img
                                                                            src={FullLoader}
                                                                            alt="USP"
                                                                            className="loader_icon"
                                                                        />
                                                                    </div>
                                                                    <span>Export</span>
                                                                </button>
                                                                :
                                                                paginationProcess === "backend" && !exportBackendLoading ?
                                                                    <button className="btn btn_export "
                                                                        onClick={() => { getDataViaBackend(dateRangePreviousApplied, platformListPreviousApplied, countryListPreviousApplied, publisherListPreviousApplied, zoneListPreviousApplied, domainListPreviousApplied, mobileListPreviousApplied, ctvListPreviousApplied, trafficTypeListPreviousApplied, deviceTypeListPreviousApplied, dimensionsListPreviousApplied, search, "", sortObject, 1) }}
                                                                        disabled={totalAdkRecords > 200000}
                                                                        style={{ pointerEvents: totalAdkRecords > 200000 ? "none" : "" }}
                                                                    >
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                            <g clip-path="url(#clip0_11006_24214)">
                                                                                <path d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M4.08423 5.83325L7.0009 8.74992L9.91756 5.83325" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M7 8.75V1.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                            </g>
                                                                            <defs>
                                                                                <clipPath id="clip0_11006_24214">
                                                                                    <rect width="14" height="14" fill="white" />
                                                                                </clipPath>
                                                                            </defs>
                                                                        </svg>

                                                                        <span>Export</span>
                                                                    </button>

                                                                    :
                                                                    <></>

                                                            // <Button
                                                            //     className="export_btn_d2"
                                                            //     onClick={() => { handleExport(exportHeader, exportData) }}
                                                            // >
                                                            //     <img src={mediaKitIcon} alt='' />
                                                            //     Export
                                                            // </Button>
                                                        }
                                                    </div>
                                                </div>
                                            }


                                            {initialLoad ?
                                                <TableLoading />

                                                :
                                                // <Table
                                                //     columns={columnsDummy}
                                                //     dataSource={dataDummy}
                                                //     pagination={false}
                                                //     scroll={{ x: 1500, y: 'calc(100vh - 32rem' }}
                                                // />

                                                <div className="reporting_table position-relative table_class_for_vertical_line">

                                                    {backendLoading && !initialLoad &&
                                                        <div className="table_new_loader_d2">
                                                            <img src={FullLoader} className="img-fluid" alt="" />
                                                        </div>
                                                    }

                                                    <Table
                                                        columns={visibleColumnsWithSortOrder}
                                                        pageSize={500}
                                                        dataSource={data}
                                                        onChange={handleTableChange}
                                                        pagination={false}
                                                        rowKey={(record) => record.id}
                                                        locale={locale}
                                                        scroll={{ x: data.length === 0 ? '1500' : 'max-content', y: 'calc(100vh - 27rem' }}
                                                        showSorterTooltip={false}
                                                        summary={() => (
                                                            data.length > 0 && search.trim().length === 0 ? (
                                                                <Table.Summary fixed >
                                                                    <Table.Summary.Row className="test" >
                                                                        {visibleColumnsWithSortOrder?.flatMap(col => col.children && !col.hidden ? col.children.filter(c => !c.hidden) : (col.hidden ? [] : [col]))?.map((column, index) => (
                                                                            <Table.Summary.Cell key={column?.key}
                                                                                index={index}
                                                                                className={index === 0 ? "summary_total" : ""}
                                                                                fixed={column.fixed}
                                                                            >
                                                                                {index === 0 ? 'TOTAL' :
                                                                                    Object.keys(total).length > 0 ?
                                                                                        (total[column.key] !== undefined && total[column.key] !== null && total[column.key] !== "-" && total[column.key] !== "") ?
                                                                                            (column.key) === "pub_revenue" || (column.key) === "pub_total_cost" || (column.key) === "profit" || (column.key) === "pub_net_ecpm" || (column.key) === "pub_rpm" || (column.key) === "pub_avg_bidfloor" ?

                                                                                                <>$ {addCommasToNumber(total[column.key])}</> :

                                                                                                (column.key) === "pub_fill_rate" || (column.key) === "pub_coverage_rate" || (column.key) === "pub_win_rate" || (column.key) === "pub_ctr" || (column.key) === "givtImpsRate" || (column.key) === "sivtImpsRate" || (column.key) === "viewability" || (column.key) === "givtSivtRate" || (column.key) === "pub_new_coverage" ?

                                                                                                    <>{addCommasToNumber(total[column.key])} %</> :

                                                                                                    addCommasToNumber(total[column.key]) : "-" : "-"}
                                                                            </Table.Summary.Cell>
                                                                        ))}
                                                                    </Table.Summary.Row>
                                                                </Table.Summary>
                                                            ) : null
                                                        )}
                                                    />
                                                </div>

                                            }
                                            {data.length > 0 &&
                                                <Row className="custom_pagination--container" ref={tableScrollRef}>
                                                    <Col span={6}>
                                                        <div className="form_content_block--group mb_0">
                                                            <Select
                                                                className='form_select basic sm no_search'
                                                                value={page.pageSize}
                                                                onChange={handlePageSizeChange}
                                                                style={{ width: 80 }}
                                                                showSearch={false}
                                                                disabled
                                                                options={[
                                                                    { value: 20, label: 20 },
                                                                    { value: 50, label: 50 },
                                                                    { value: 100, label: 100 },
                                                                    { value: 500, label: 500 },
                                                                ]} />
                                                            <label className='custom_pagination--label'>
                                                                items per page
                                                            </label>
                                                        </div>
                                                    </Col>
                                                    <Col span={6}>
                                                        <span className="custom_pagination--total-text">
                                                            {`${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${page.total} items`}
                                                        </span>
                                                    </Col>
                                                    <Col span={6}>
                                                        <Pagination
                                                            current={page.current}  // Pass individual props instead of spreading them
                                                            pageSize={page.pageSize}
                                                            total={page.total}
                                                            onChange={handlePageChange}
                                                            showSizeChanger={false}
                                                            itemRender={itemRender}
                                                            className="custom_pagination" />
                                                    </Col>
                                                </Row>
                                            }
                                        </div>
                                    </>


                                </div>
                            </div>
                        </div>
                    }




                </>
                :
                <div
                    style={{ width: "100%", height: "60vh" }}
                    className="d-flex justify-content-center align-items-center"

                >
                    <img
                        src={FullLoader}
                        width={50}
                        height={50}
                        alt="" />
                </div>
            }



        </>
    );
};

export default DemandReport;